import $ from 'jquery';

import { initNotify } from './angle/modules/elements/notify';
import initBootgrid from './angle/modules/tables/bootgrid';
import initDatatables from './angle/modules/tables/datatable';
import './angle/modules/forms/select2';
import Papa from "papaparse";

$(document).ready(function() {
    //select company staff seller
    console.log("sellers js")
    $(document).on("click", "#export-products", function() {
        let sellerId = $(this).data("seller-id");
        console.log("exporting products", sellerId)


        fetch("/products/export_files", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": $("meta[name='csrf-token']").attr("content")
            },
            body: JSON.stringify({ seller_id: sellerId })  // no `products` array
        })
            .then(response => {
                if (!response.ok) throw new Error("Failed to export products.");
                return response.blob();
            })
            .then(blob => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement("a");
                a.href = url;
                a.download = "products_export.csv";
                document.body.appendChild(a);
                a.click();
                a.remove();
            })
            .catch(error => {
                alert("Export failed: " + error.message);
            });
    });
    $("#editSellerProfile").on("change", ".upload-seller-profile", function() {
        console.log('image upload trigger 3434');
        readURL(this, $("#editSellerProfile").find(".image-container .image"));
    });
    function capitalize(string) {
        if (!string) return string; // Handle empty strings
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    function readURL(input, container) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = function(e) {
                container.attr('src', e.target.result);
                $("#createCategory").find(".image-container").removeClass("hide");
                $("#createCategory").find(".image-button").addClass("hide");
            }

            reader.readAsDataURL(input.files[0]);
        }
    }
    $(".register-seller").find(".checkbox input", function() {
        console.log('is checked');
        if ($(this).is(":checked")) {
            $(".register-seller").find(".register-button").removeClass("disabled");
        }
        else {
            $(".register-seller").find(".register-button").addClass("disabled");
        }
    });
    //moved country-select on change
    $('.country-select').on('change', function() {
        var selectedCountry = $(this).val();
        $(document).find('#editSellerProfile .country-input-container input#store-country').val(selectedCountry);
        $(document).find('#editSellerProfile .country-input-container input#store-country').attr('value', selectedCountry);
        console.log('country changed', selectedCountry)
    })
    if ($(".seller-profile").length) {
        $(".select-company-staff").on("change", function() {
            console.log('staff company changed')
            var staff_image = $(document).find('.company-staff-profile-image')
            var name = $(document).find('.contact-information').find('.name')
            var status = $(document).find('.contact-information').find('.staff-status')
            var role = $(document).find('.contact-information').find('.role')
            var department = $(document).find('.contact-information').find('.department')
            var phone_number = $(document).find('.contact-information').find('.phone_number')
            var mobile = $(document).find('.contact-information').find('.mobile')
            var email = $(document).find('.contact-information').find('.email')
            var address1 = $(document).find('.contact-information').find('.address1')
            var address2 = $(document).find('.contact-information').find('.address2')
            var edit_button = $(document).find('.profile-card-header').find('button.edit-staff')
            $.ajax({
                type: "GET",
                url: "../api/staff/" + $(this).val() + "?is_seller=" + true + "",
                success: function(result) {
                    if (result.status === 200) {
                        var staff = result.data
                        var additional_details = result.data.staff_details
                        var s = staff.status
                        var full_address = additional_details.province !== null && additional_details.city.length > 0 ? (additional_details.province +
                            (additional_details.city !== null && additional_details.city.length > 0 ? ", " + additional_details.city : "") +
                            (additional_details.town !== null && additional_details.town.length > 0 ? ", " + additional_details.town : "") +
                            (additional_details.street !== null && additional_details.street.length > 0 ? ", " + additional_details.street : ""))
                            : "";
                        var badge = s === 'active'
                            ? 'success'
                            : s === 'pending'
                                ? 'pending'
                                : s === 'inactive'
                                    ? 'danger'
                                    : 'blocked';
                        console.log('result data:', result)
                        staff_image.attr("src", result.data.profile_image)
                        name.text(result.data.first_name + " " + result.data.last_name)
                        console.log("image loaded")
                        if (result.data.role === 'Seller') {
                            role.text("Admin")
                        }
                        else {
                            role.text("Staff")
                        }
                        phone_number.text(additional_details.phone_number)
                        edit_button.attr('sf_id', result.data.id)
                        mobile.text(result.data.phone_number)
                        email.text(result.data.email)
                        department.text(additional_details.department)
                        address1.text(result.data.address1 ?? full_address)
                        address2.text(result.data.address2)
                        status.html(
                            "<div class='badge badge-" + badge + "'>" + capitalize(staff.status) + "</div>"
                        )
                    }
                }
            });
        })
        if ($(".select-company-staff").val().length) {
            var staff_image = $(document).find('.company-staff-profile-image')
            var name = $(document).find('.contact-information').find('.name')
            var role = $(document).find('.contact-information').find('.role')
            var status = $(document).find('.contact-information').find('.staff-status')
            var department = $(document).find('.contact-information').find('.department')
            var phone_number = $(document).find('.contact-information').find('.phone_number')
            var mobile = $(document).find('.contact-information').find('.mobile')
            var email = $(document).find('.contact-information').find('.email')
            var address1 = $(document).find('.contact-information').find('.address1')
            var address2 = $(document).find('.contact-information').find('.address2')
            var edit_button = $(document).find('.profile-card-header').find('button.edit-staff')
            $.ajax({
                type: "GET",
                url: "../api/staff/" + $(".select-company-staff").val() + "?is_seller=" + true + "",
                success: function(result) {
                    if (result.status === 200) {
                        var additional_details = result.data.staff_details
                        var staff = result.data
                        var s = staff.status
                        var full_address = additional_details.province !== null && additional_details.city.length > 0 ? (additional_details.province +
                            (additional_details.city !== null && additional_details.city.length > 0 ? ", " + additional_details.city : "") +
                            (additional_details.town !== null && additional_details.town.length > 0 ? ", " + additional_details.town : "") +
                            (additional_details.street !== null && additional_details.street.length > 0 ? ", " + additional_details.street : ""))
                            : "";
                        var badge = s === 'active'
                            ? 'success'
                            : s === 'pending'
                                ? 'pending'
                                : s === 'inactive'
                                    ? 'danger'
                                    : 'blocked';
                        staff_image.attr("src", result.data.profile_image)
                        name.text(result.data.first_name + " " + result.data.last_name)
                        console.log("image loaded")
                        if (result.data.role === 'Seller') {
                            role.text("Admin")
                        }
                        else {
                            role.text("Staff")
                        }
                        phone_number.text(additional_details.phone_number)
                        edit_button.attr('sf_id', result.data.id)
                        mobile.text(result.data.phone_number)
                        email.text(result.data.email)
                        department.text(additional_details.department)
                        address1.text(result.data.address1 ?? full_address)
                        address2.text(result.data.address2)
                        status.html(
                            "<div class='badge badge-" + badge + "'>" + capitalize(staff.status) + "</div>"
                        )
                    }
                }
            });
        }//end of select staff
        $(document).on("click", ".edit-staff", function() {
            let fullname = $(document).find('.value.name').html()
            let $editStaff = $("#editStaff");
            $editStaff.find(".error").addClass('hide');
            $editStaff.find(".message").addClass('hide');
            var isEditPhoneOrLandline = false;
            var $staff = null;
            var staff_id = $(this).attr("sf_id")
            $.ajax({
                type: "GET",
                url: "/admins/fetch",
                data: { staff_id: staff_id },
                success: function(result) {
                    if (result.status == 200) {
                        console.log(result);
                        $editStaff.find("input.name").val(fullname);
                        $editStaff.find(".staff-id").val(staff_id);
                        console.log($(this).attr('sf_id'), $('.staff-id').val(), staff_id);
                        $staff = result.staff;

                        if ($staff) {
                            $.each($staff, function(key, val) {
                                console.log(key);
                                if (key == 'image') {
                                    $editStaff.find('img.image').attr('src', val === null ? "https://estorephilbucketv1.s3.us-west-2.amazonaws.com/assets/images/profile_image_default.jpg" : val);
                                } else {
                                    if ($editStaff.find("." + key).length > 0) {
                                        $editStaff.find("." + key).val(val);
                                    }
                                }
                            });
                        }
                    }
                    else {
                        $editStaff.find(".error").removeClass("hide").html(result.error);
                    }
                }
            });
        });

        $(".select-company-staff").select2(
            {
                theme: 'bootstrap4',
                placeholder: "Select company staff",
                templateResult: formatState,
                templateSelection: formatSelection
            }
        );
    }

    function formatState(state) {
        if (!state.id) {
            return state.text;
        }
        var $state = $(
            '<span class="' + state.title + '" >' + state.text + '<em class="fa fas fa-plus"></em><em class="fa fas fa-minus"></em></span>'
        );
        return $state;
    };

    function formatSelection(state) {
        console.log('state data', state, !state.id)
        if (!state.id) {
            console.log('returning state text', state.text)
            return state.text;
        }
        console.log('not called')
        var $state = $("<span>" + state.text + "</span>");
        $state.find("span").remove();
        return $state;
    };
    //end of select company staff
    var $wrapper = $('.modal-open .wrapper');
    $('.openTermsConditionModal').on('click', function() {
        console.log('modal is opened');
        $wrapper.css(
            'z-index', 'auto',
        )
        // $('#termsConditionModal').addClass('show');
    });
    var editProvinceSelect = $('#edit-profile-branch-province');
    var editCountrySelect = $('#edit-profile-branch-country');

    var provincesByCountry = {
        'Canada': ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador', 'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Yukon Territory'],
        'Philippines': ["Ilocos Norte", "Ilocos Sur", "La Union", "Pangasinan", "Batanes", "Cagayan", "Isabela", "Nueva Vizcaya", "Quirino", "Bataan", "Bulacan", "Nueva Ecija", "Pampanga", "Tarlac", "Zambales", "Aurora", "Batangas", "Cavite", "Laguna", "Quezon", "Rizal", "Marinduque", "Occidental Mindoro", "Oriental Mindoro", "Palawan", "Romblon", "Albay", "Camarines Norte", "Camarines Sur", "Catanduanes", "Masbate", "Sorsogon", "Aklan", "Antique", "Capiz", "Iloilo", "Negros Occidental", "Guimaras", "Bohol", "Cebu", "Negros Oriental", "Siquijor", "Eastern Samar", "Leyte", "Northern Samar", "Samar (Western Samar)", "Southern Leyte", "Biliran", "Zamboanga Del Norte", "Zamboanga Del Sur", "Zamboanga Sibugay", "City Of Isabela", "Bukidnon", "Camiguin", "Lanao Del Norte", "Misamis Occidental", "Misamis Oriental", "Davao Del Norte", "Davao Del Sur", "Davao Oriental", "Compostela Valley", "Davao Occidental", "Cotabato (North Cotabato)", "South Cotabato", "Sultan Kudarat", "Sarangani", "Cotabato City", "Ncr, City Of Manila, First District", "Ncr, Second District", "Ncr, Third District", "Ncr, Fourth District", "Abra", "Benguet", "Ifugao", "Kalinga", "Mountain Province", "Apayao", "Basilan", "Lanao Del Sur", "Maguindanao", "Sulu", "Tawi-tawi", "Agusan Del Norte", "Agusan Del Sur", "Surigao Del Norte", "Surigao Del Sur", "Dinagat Islands"],
        'USA': ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming']
    };
    function set_provinces() {
        var selectedCountry = editCountrySelect.val();
        var provinces = provincesByCountry[selectedCountry]
        var storedProvince = $('#selected-province').val()
        var selectedProvince = "";
        if (provinces) {
            provinces.sort()
        }
        console.log('values', provincesByCountry, selectedCountry);
        console.log('edit country called', storedProvince);
        console.log('provinces', provinces);
        // Clear existing province options (except for the "Select province" option)
        editProvinceSelect.find('option:not(:first)').remove();

        // Append new province options based on the selected country
        editProvinceSelect.append('<option value="" class="hide disabled" disabled=true>Select Province </option>');
        $.each(provinces, function(index, province) {
            var isSelected = storedProvince == province
            if (isSelected) {
                selectedProvince = province;
            }
            else {
                editProvinceSelect.append('<option value="' + province + '" selected="' + isSelected + '">' + province + '</option>');
            }
            console.log('is province selected', isSelected)
        });
        editProvinceSelect.append('<option value="' + selectedProvince + '" selected="selected" style="display: none;">' + selectedProvince + '</option>');

        if (selectedCountry === "Philippines") {
            $("#editSellerBranch input[name='store_branch[zip_code]']").prop('type', 'number');
        } else {
            $("#editSellerBranch input[name='store_branch[zip_code]']").prop('type', 'text');
        }
    }
    editCountrySelect.on('change', function() {
        var selectedCountry = $(this).val();
        var provinces = provincesByCountry[selectedCountry].sort();
        if (provinces) {
            provinces.sort()
        }
        // Clear existing province options (except for the "Select province" option)
        editProvinceSelect.find('option:not(:first)').remove();

        // Append new province options based on the selected country
        editProvinceSelect.append('<option value="" class="hide disabled" disabled=true>Select Province </option>');
        $.each(provinces, function(index, province) {
            editProvinceSelect.append('<option value="' + province + '">' + province + '</option>');
        });

        if (selectedCountry === "Philippines") {
            $("#editSellerBranch input[name='store_branch[zip_code]']").prop('type', 'number');
        } else {
            $("#editSellerBranch input[name='store_branch[zip_code]']").prop('type', 'text');
        }
    });
    editCountrySelect.ready(set_provinces());

    if ($(".seller-staffs").length) {

        $("#editStaff").on("change", ".upload-user-profile", function() {
            readURL(this, $("#editStaff").find(".image-container .image"));
        });

        $(document).on("click", ".btn-invite-staff", function() {
            var $popup = $("#inviteStaff");
            $popup.find(".email, .first-name, .last-name").val("");
            $popup.find(".email").get(0).focus();
            $popup.find(".loading-div.whirl.no-overlay").addClass("hide");
            $popup.find(".buttons-row").removeClass("hide");
            $popup.find(".message, .error").html("");
            $popup.find(".message, .error, .btn-confirm").addClass("hide");
            $popup.find(".btn-send-invite, .btn-cancel").removeClass("hide");
        });

        $(".seller-staffs").on("click", ".tabs .tab", function() {
            let $this = $(this);
            let $tabs = $(".tabs");
            $(".staff-table").find(".staff-row").removeClass("hide");
            if ($this.hasClass("active")) {
                $this.removeClass("active");
            }
            else {
                $tabs.find(".tab.active").removeClass("active");
                $this.addClass("active");
                $(".staff-table").find(".staff-row.status-" + $tabs.find(".tab:not(.active)").attr("value")).addClass("hide");
            }
        });

        $("#inviteStaff").on("click", ".btn-send-invite", function() {
            var $popup = $("#inviteStaff");
            if ($popup.find(".email").val() != "") {
                var $form = $popup.find(".admin-info");
                $popup.find(".loading-div.whirl.no-overlay").removeClass("hide");
                $popup.find(".buttons-row").addClass("hide");
                $popup.find(".message, .error").html("");
                $.ajax({
                    type: "POST",
                    url: "/admins/send_invitation",
                    data: new FormData($form[0]),
                    contentType: false,
                    cache: false,
                    processData: false,
                    success: function(result) {
                        if (result.status != 300) {
                            $popup.find(".message").html(result.message);
                            $popup.find(".message, .btn-confirm").removeClass("hide");
                            $popup.find(".btn-send-invite, .btn-cancel").addClass("hide");

                            setTimeout(() => {
                                window.location.reload();
                            }, 500);
                        }
                        else {
                            $popup.find(".error").html(result.error);
                            $popup.find(".error").removeClass("hide");
                            $popup.find(".btn-send-invite, .btn-cancel").removeClass("hide");
                        }
                        $popup.find(".buttons-row").removeClass("hide");
                        $popup.find(".whirl.no-overlay").addClass("hide");
                    }
                });
            }
        });

        let $staff = null;
        let errmesg = "";
        var isEditPhoneOrLandline = false;
        $(document).on("click", ".edit-staff", function() {
            let $this = $(this);
            let fullname = $this.parents("tr").find(".name .fullname").html();
            let $editStaff = $("#editStaff");
            $editStaff.find(".error").addClass('hide');
            $editStaff.find(".message").addClass('hide');
            isEditPhoneOrLandline = false;
            $staff = null;
            $.ajax({
                type: "GET",
                url: "/admins/fetch",
                data: { staff_id: $this.attr("sf_id") },
                success: function(result) {
                    if (result.status == 200) {
                        console.log(result);
                        $editStaff.find("input.name").val(fullname);
                        $editStaff.find(".staff-id").val($this.attr("sf_id"));
                        $staff = result.staff;

                        if ($staff) {
                            $.each($staff, function(key, val) {
                                console.log(key);
                                if (key == 'image') {
                                    $editStaff.find('img.image').attr('src', val === null ? "https://estorephilbucketv1.s3.us-west-2.amazonaws.com/assets/images/profile_image_default.jpg" : val);
                                } else {
                                    if ($editStaff.find("." + key).length > 0) {
                                        $editStaff.find("." + key).val(val);
                                    }
                                }
                            });
                        }
                    }
                    else {
                        $editStaff.find(".error").removeClass("hide").html(result.error);
                    }
                }
            });
        });

        $("#editStaff").on("click", ".btn-reset", function() {
            isEditPhoneOrLandline = false;
            setEditStaff();
        });

        $("#editStaff").on("click", ".btn-update", function() {
            let $editStaff = $("#editStaff");

            $editStaff.find("form, .main-buttons-row").addClass("hide");
            $editStaff.find(".loading-row").removeClass("hide");

            console.log("ASDS", isEditPhoneOrLandline);
            if (isEditPhoneOrLandline === false || (isEditPhoneOrLandline === true && validatePhoneNumber() && validateLandline())) {
                $.ajax({
                    type: "PUT",
                    url: "/admins/update_staff",
                    data: new FormData($editStaff.find("form")[0]),
                    contentType: false,
                    cache: false,
                    processData: false,
                    success: function(result) {
                        $editStaff.find(".loading-row").addClass("hide");
                        $editStaff.find("form, .message-row, .main-buttons-row").removeClass("hide");
                        if (result.status == 200) {
                            $editStaff.find(".error").addClass("hide").html("");
                            $editStaff.find(".message").removeClass("hide").html(result.message);
                        }
                        else {
                            $editStaff.find(".message").addClass("hide").html("");
                            $editStaff.find(".error").removeClass("hide").html(result.error);
                        }
                        setTimeout(() => {
                            $editStaff.find(".close").trigger('click');
                            window.location.reload();
                        }, 800);
                    }
                });
                isEditPhoneOrLandline = false;
            } else {
                $editStaff.find(".loading-row").addClass("hide");
                $editStaff.find("form, .message-row, .main-buttons-row").removeClass("hide");
                $editStaff.find(".message").addClass("hide").html("");
                $editStaff.find(".error").removeClass("hide").html(errmesg);
            }
        });

        $("#editStaff").on('keypress', "input[name='store_staff[phone_number]']", function(e) {
            var phoneNumber = $(this).val();
            if (phoneNumber.length >= 11) {
                e.preventDefault();
                return false;
            }
        });

        $("#editStaff").on('keyup', "input[name='store_staff[landline]'], input[name='store_staff[phone_number]']", function(e) {
            if (e.which != 8 && e.which != 0 && e.which < 48 || e.which > 57) {
                if (e.which == 8) {
                    isEditPhoneOrLandline = true;
                }
                e.preventDefault();
            }
            isEditPhoneOrLandline = true;
        });

        function validateLandline() {
            var isValid = true;
            var phoneNumber = $("input[name='store_staff[landline]']").val();
            var phoneNumberPattern = /^(?:(?:\+63)|0)?(?:\d{1,3}|\([2-9]\d{1,3}\))(?:\d{7}|\d{6})$/;

            if (phoneNumberPattern.test(phoneNumber)) {
                // The phone number is valid
                console.log("Valid landline: " + phoneNumber);
            } else {
                // The phone number is not valid
                console.log("Invalid landline: " + phoneNumber);

                isValid = false
                errmesg = "Invalid landline";
                // $errorTab = "#availability";
            }

            return isValid;
        }

        function validatePhoneNumber() {
            var phoneNumber = $("input[name='store_staff[phone_number]").val();
            var phoneNumberPattern = /^(09|\+639|639)\d{9}$/;
            var isValid = false;

            if (phoneNumberPattern.test(phoneNumber)) {
                // The phone number is valid
                console.log("Valid phone number: " + phoneNumber);
                isValid = true;
            } else {
                // The phone number is not valid
                console.log("Invalid phone number: " + phoneNumber);
                errmesg = "Invalid phone number";
                isValid = false;
            }

            return isValid;
        }

        $(document).on("click", ".deactivate-staff", function() {
            let $this = $(this);
            let $deactivateStaff = $("#deactivateStaff");
            let fullname = $this.parents("tr").find(".name .fullname").html();

            $deactivateStaff.find(".name").html(fullname);

            $deactivateStaff.find(".btn-deactivate").attr("sf_id", $this.attr("sf_id"));
        });

        $("#deactivateStaff").on("click", ".btn-deactivate", function() {
            let $this = $(this);
            let $deactivateStaff = $("#deactivateStaff");

            $deactivateStaff.find("form, .main-buttons-row").addClass("hide");
            $deactivateStaff.find(".loading-row").removeClass("hide");
            $.ajax({
                type: "POST",
                url: "/admins/disable",
                data: { staff_id: $this.attr("sf_id") },
                success: function(result) {
                    $deactivateStaff.find(".loading-row").addClass("hide");
                    $deactivateStaff.find(".message-row").removeClass("hide");
                    $deactivateStaff.find(".deactivate-question").addClass("hide");
                    if (result.status == 200) {
                        $deactivateStaff.find(".message").removeClass("hide").html(result.message);
                        setTimeout(function() {
                            $deactivateStaff.find(".btn-cancel").trigger("click");
                            window.location.reload();
                        }, 1000);
                    }
                    else {
                        $deactivateStaff.find(".error").removeClass("hide").html(result.error);
                        $deactivateStaff.find(".main-buttons-row").removeClass("hide");
                    }
                }
            });
        });

        $(document).on("click", ".reactivate-staff", function() {
            let $this = $(this);
            let $reactivateStaff = $("#reactivateStaff");
            let fullname = $this.parents("tr").find(".name .fullname").html();

            $reactivateStaff.find(".name").html(fullname);

            $reactivateStaff.find(".btn-reactivate").attr("sf_id", $this.attr("sf_id"));
        });

        $("#reactivateStaff").on("click", ".btn-reactivate", function() {
            let $this = $(this);
            let $reactivateStaff = $("#reactivateStaff");

            $reactivateStaff.find("form, .main-buttons-row").addClass("hide");
            $reactivateStaff.find(".loading-row").removeClass("hide");
            $.ajax({
                type: "POST",
                url: "/admins/enable",
                data: { staff_id: $this.attr("sf_id") },
                success: function(result) {
                    $reactivateStaff.find(".loading-row").addClass("hide");
                    $reactivateStaff.find(".message-row").removeClass("hide");
                    if (result.status == 200) {
                        $reactivateStaff.find(".message").removeClass("hide").html(result.message);
                        $reactivateStaff.find(".reactivate-question").addClass("hide");
                        setTimeout(function() {
                            $reactivateStaff.find(".btn-cancel").trigger("click");
                            window.location.reload();
                        }, 1000);
                    }
                    else {
                        $reactivateStaff.find(".error").removeClass("hide").html(result.error);
                        $reactivateStaff.find(".main-buttons-row").removeClass("hide");
                    }
                }
            });
        });

        $(".seller-staffs").on("click", ".staff-row .btn-reset", function() {
            let $popup = $("#resetSellerPassword");
            $popup.find(".main-buttons-row").removeClass("hide");
            $popup.find(".btn-reset").attr("sellerId", $(this).attr("sellerId"));
            $popup.find(".seller-info input.my-2").val("");
            $popup.find(".error, .message").html("");
        });

        $("#resetSellerPassword").on("click", ".btn-reset", function() {
            var $this = $(this);
            var $popup = $this.parents(".modal-body");
            var $sellerId = $this.attr("sellerId");
            var $form = $popup.find("form");
            $popup.find(".loading-row").removeClass("hide");
            $popup.find("button.close").css("visibility", "hidden");
            $popup.find(".message-row, .message, .error, .main-buttons-row").addClass("hide");
            $popup.find(".error, .message").html("");
            $.ajax({
                type: "PUT",
                url: "../sellers/" + $sellerId + "/reset_password",
                data: new FormData($form[0]),
                contentType: false,
                cache: false,
                processData: false,
                success: function(result) {
                    $popup.find("button.close").css("visibility", "visible");
                    $popup.find(".loading-row").addClass("hide");
                    if (result.status == 200) {
                        $popup.find(".message-row, .message").removeClass("hide");
                        $popup.find(".message-row .message").html(result.message);

                        setTimeout(function() {
                            $popup.find(".btn-cancel").trigger("click");
                        }, 1000);
                    }
                    else {
                        $popup.find(".message-row, .error").removeClass("hide");
                        $popup.find(".message-row .error").html(result.error);
                        $popup.find(".main-buttons-row").removeClass("hide");
                    }
                },
                error: function(result) {
                }
            });
        });

        function setEditStaff() {
            let $editStaff = $("#editStaff");
            if ($staff) {
                $.each($staff, function(key, val) {
                    if ($editStaff.find("." + key).length > 0) {
                        $editStaff.find("." + key).val(val);
                    }
                });
            }
        }
    }

});

$(function() {
    initBootgrid();
    initDatatables();
    // initTableCheckAll();
    initNotify();
    // initSellerFlotArea();

    function checkFileSize(file, maxSize) {
        var size = file.files[0].size;
        var mb = 0;
        var k = 1024;
        var m = 1000;
        var compare = k * m;
        mb = size / compare;

        return (mb > maxSize);
    }

    if ($(".seller-profile").length) {
        var $sellerContacts = $(".seller-content.contacts");
        // $(".country-select").select2({
        //   theme: 'bootstrap4',
        //   placeholder: "Select Country",
        //   templateResult: formatState
        // });

        $sellerContacts.on("click", ".image", function() {
            $sellerContacts.find(".image").removeClass("focused");
            $(this).addClass("focused");
            $sellerContacts.find(".contact-information").addClass("hide");
            $sellerContacts.find(".contact-information[staff_id=" + $(this).attr("staff_id") + "]").removeClass("hide");
        });

        // var country_arr = [];
        // $("#editSellerProfile .country-input-container input[name='store_detail[countries][]']").each(function () {
        //   if ($(this).val() != undefined) {
        //     country_arr.push($(this).val());
        //   }
        // });
        // $(".country-select").val(country_arr).trigger('change');

        function formatState(state) {
            // console.log("state " + JSON.stringify(state))
            if (!state.id) {
                return state.text;
            }
            var $state = $(
                '<span class="' + state.title + '" >' + state.text + '<em class="fa fas fa-plus"></em><em class="fa fas fa-minus"></em></span>'
            );
            return $state;
        };

        if ($(".seller-profile").attr("isinterviewed") == "true") {
            $(".aside-container").remove();
            $(".section-container").css("margin", "0");
        }

        $(".seller-profile").on("click", ".contacts .image-container .image", function() {
            console.log('image upload trigger');
            $(this).parents(".image-container").find(".image").removeClass("focused");
            $(this).addClass("focused");
        });

        $("#editImageBannerModal").find(".banner-image")[0].onload = function() {
            $("#editImageBannerModal").find(".loading-row").addClass("hide");
            $("#editImageBannerModal").find("button.close").css("visibility", "visible");
        };
        $("#editImageBannerModal").find(".profile-image")[0].onload = function() {
            $("#editImageBannerModal").find(".loading-row").addClass("hide");
            $("#editImageBannerModal").find("button.close").css("visibility", "visible");
        };

        $("#editImageBannerModal").on("change", ".upload-banner, .upload-profile, .upload-logo", function() {
            var $this = $(this);
            var $val = $this.val();
            var $sellerId = $(".seller-profile").attr("sellerId");
            var $form = $this.parents("form");
            if (checkFileSize(this, 5)) {
                $('#loadingModal').find(".loading-row").addClass("hide");
                $('#loadingModal').find(".message-row, .button-row").removeClass("hide");
                $('#loadingModal').find(".message, .error").addClass("hide").html("");
                $('#loadingModal').find(".error").removeClass("hide").html("Image file must be less than 5mb");
                $("button.loading-btn").click();
                $(this).val("");
            }
            else if ($val != "") {
                $("#editImageBannerModal").find(".loading-row").removeClass("hide");
                $("#editImageBannerModal").find("button.close").css("visibility", "hidden");
                $.ajax({
                    type: "PUT",
                    url: "/sellers/" + $sellerId + "/upload_image",
                    data: new FormData($form[0]),
                    contentType: false,
                    cache: false,
                    processData: false,
                    success: function(result) {
                        if (result.status == 200) {
                            // console.log(result.message)
                            var $image = result.image;
                            if ($this.attr("image_type") == "banner") {
                                $(".seller-profile").find(".images-container .banner").attr("src", $image.url);
                                $("#editImageBannerModal").find(".banner-image").attr("src", $image.url);
                            }
                            else if ($this.attr("image_type") == "logo") {
                                $(".seller-profile").find(".images-container .logo-container .logo-image").attr("src", $image.url).removeClass("hide");
                                $(".seller-profile").find(".images-container .logo-container p").addClass("hide");
                                $("#editImageBannerModal").find(".logo-image").attr("src", $image.url).removeClass("hide");
                                $("#editImageBannerModal").find(".logo-image-container p").addClass("hide");
                            }
                            else {
                                $(".seller-profile").find(".images-container .banner-information .image").attr("src", $image.url);
                                $("#editImageBannerModal").find(".profile-image").attr("src", $image.url);
                            }
                            $("#editImageBannerModal").find("button.close").css("visibility", "visible");
                            $("#editImageBannerModal").find(".loading-row").addClass("hide");
                        }
                        else {
                            $("#editImageBannerModal").find("button.close").css("visibility", "visible");
                            $("#editImageBannerModal").find(".loading-row").addClass("hide");
                            console.log(result.error);
                        }
                    },
                    error: function(result) {
                    }
                });
            }
        });

        $("#editSellerProfile").on("change", ".upload-seller-profile", function() {
            console.log('image upload trigger 2');
            readURL(this, $("#editSellerProfile").find(".image-container .image"));
        });

        $("#editSellerProfile").on("click", ".btn-reset", function() {
            var $parent = $(this).parents(".modal-body");
            $parent.find("form").find("input").each(function() {
                var $this = $(this);
                $this.val($this.attr("default_value"));
            });
        });

        $("#editSellerProfile").on("click", ".btn-update", function() {
            console.log('method 1 called')
            var $this = $(this);
            var $popup = $(this).parents(".modal");
            var $val = $this.val();
            var $sellerId = $(".seller-profile").attr("sellerId");
            var $form = $popup.find("form");
            $popup.find(".loading-row").removeClass("hide");
            $popup.find("button.close").css("visibility", "hidden");
            $popup.find(".message-row, .message").removeClass("hide");
            // $form.find(".country-input-container").html("");
            // $.each($(".country-select").select2().val(), function (i, val) {
            //   $('<input>').attr({
            //     type: 'hidden',
            //     name: 'store_detail[countries][]',
            //     value: val
            //   }).appendTo($(".country-input-container"));
            // });
            $.ajax({
                type: "PUT",
                url: "/sellers/" + $sellerId + "/update_info",
                data: new FormData($form[0]),
                contentType: false,
                cache: false,
                processData: false,
                success: function(result) {
                    $popup.find("button.close").css("visibility", "visible");
                    $popup.find(".loading-row").addClass("hide");
                    if (result.status == 200) {
                        $form.find("input").each(function() {
                            var $this = $(this);
                            $this.attr("default_value", $this.val());
                            $(".seller-profile").find($this.attr("display")).html($this.val());
                        });
                        $popup.find(".message-row, .message").removeClass("hide");
                        $popup.find(".message-row .message").html(result.message);

                        $popup.find('.modal-header button.close').toggle();
                        // window.location.reload();
                        window.location.href = "/profile";
                    }
                    else {
                        $popup.find(".message-row, .error").removeClass("hide");
                        $popup.find(".message-row .error").html(result.error);
                    }
                },
                error: function(result) {
                }
            });
        });
        var errmesg = "";
        $("#editSellerBranch").on("click", ".btn-update", function() {
            var $this = $(this);
            var $popup = $(this).parents(".modal");
            var $val = $this.val();
            var $sellerId = $(".seller-profile").attr("sellerId");
            var $form = $popup.find("form");
            var $email = $("input[name='store_branch[email]']");

            $popup.find(".loading-row").removeClass("hide");
            $popup.find("button.close").css("visibility", "hidden");
            $popup.find(".message-row, .message").removeClass("hide");

            console.log(checkEmailFormat($email))

            if (checkEmailFormat($email) && validateLandline()) {
                $.ajax({
                    type: "PUT",
                    url: "/sellers/" + $sellerId + "/update_main_branch",
                    data: new FormData($form[0]),
                    contentType: false,
                    cache: false,
                    processData: false,
                    success: function(result) {
                        $popup.find("button.close").css("visibility", "visible");
                        $popup.find(".loading-row").addClass("hide");
                        if (result.status == 200) {
                            // $form.find("input").each(function () {
                            //   var $this = $(this);
                            //   $this.attr("default_value", $this.val());
                            //   $(".seller-profile").find($this.attr("display")).html($this.val());
                            // });
                            $popup.find(".message-row, .message").removeClass("hide");
                            $popup.find(".message-row .message").html(result.message);

                            $popup.find('.modal-header button.close').toggle();
                            // window.location.reload();
                            window.location.href = "/profile";
                        }
                        else {
                            $popup.find(".message-row, .error").removeClass("hide");
                            $popup.find(".message-row .error").html(result.error);
                        }
                    },
                    error: function(result) {
                    }
                });
                $popup.find(".message-row, .error").addClass("hide");

            } else {
                $popup.find(".message-row, .error").removeClass("hide");
                $popup.find(".message-row .error").html(errmesg);
                $popup.find(".loading-row").addClass("hide");
            }
        });

        $("#editSellerBranch").on("click", ".btn-reset", function() {
            var $parent = $(this).parents(".modal-body");
            $parent.find("form").find("input").each(function() {
                var $this = $(this);
                $this.val($this.attr("default_value"));
            });
        });

        $('#editSellerBranch').on('keypress', ".main-branch-landline, .main-branch-mobile", function(e) { // removed: , .main-branch-zipcode[type='text']
            // if (e.which != 8 && e.which != 0 && e.which < 48 || e.which > 57) {
            //   e.preventDefault();
            // }
            var charCode = e.which || e.keyCode;

            // Allow backspace (8), tab (9), delete (46), arrow keys (37-40), and other control keys
            if (charCode == 8 || charCode == 9 || charCode == 46 || (charCode >= 37 && charCode <= 40)) {
                return;
            }

            // Allow +, (, ), numbers (0-9), and space (32)
            if (!/[0-9()+\s]/.test(String.fromCharCode(charCode))) {
                e.preventDefault();
            }
        });

        function validateLandline() {
            var isValid = true;
            var phoneNumber = $("input[name='store_branch[landline]']").val();
            var phoneNumberPattern = /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?|(^\+[1-9]\d{1,14}$)|(\d{9,14})$/;
            var country = $("#editSellerBranch").find("#edit-profile-branch-country").val();

            if (country == 'Canada') {
                phoneNumberPattern = /^(\+?1 ?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

            } else {
                // phoneNumberPattern = /^\+?63(?:[2-9]\d{1,3}|\([2-9]\d{1,3}\))(?:\d{7}|\d{1,3}-\d{4})$/;
                phoneNumberPattern = /^(?:(?:\+63)|0)?(?:\d{1,3}|\([2-9]\d{1,3}\))(?:\d{7}|\d{6})$/;
            }

            if (phoneNumberPattern.test(phoneNumber)) {
                // The phone number is valid
                console.log("Valid phone number: " + phoneNumber);
            } else {
                // The phone number is not valid
                console.log("Invalid phone number: " + phoneNumber);

                isValid = false
                errmesg = "Invalid landline";
                // $errorTab = "#availability";
            }

            return isValid;
        }


        function checkEmailFormat($email) {
            var x = $email.val();
            var regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;


            if (regex.test(x)) {
                return true;
            } else {
                errmesg = "Incorrect Email format";
                return false;
            }

        }

        $("#resetPassword").on("click", ".btn-reset", function() {
            var $this = $(this);
            var $popup = $(this).parents(".modal-body");
            var $sellerId = $(".seller-profile").attr("sellerId");
            var $form = $popup.find("form");
            $popup.find(".loading-row").removeClass("hide");
            $popup.find("button.close").css("visibility", "hidden");
            $popup.find(".error, .message").html("");
            $popup.find(".message-row, .message, .error").addClass("hide");
            $.ajax({
                type: "PUT",
                url: "/sellers/" + $sellerId + "/reset_password",
                data: new FormData($form[0]),
                contentType: false,
                cache: false,
                processData: false,
                success: function(result) {
                    $popup.find("button.close").css("visibility", "visible");
                    $popup.find(".loading-row").addClass("hide");
                    if (result.status == 200) {
                        $popup.find(".message-row, .message").removeClass("hide");
                        $popup.find(".message-row .message").html(result.message);
                    }
                    else {
                        $popup.find(".message-row, .error").removeClass("hide");
                        $popup.find(".message-row .error").html(result.error);
                    }
                },
                error: function(result) {
                }
            });
        });

        $(".seller-profile").on("change", ".upload-doc", function() {
            var $val = $(this).val();
            var $sellerId = $(".seller-profile").attr("sellerId");
            var $form = $(".seller-profile").find(".upload-form");

            $('#loadingModal').find(".loading-row").removeClass("hide");
            $('#loadingModal').find(".message-row, .button-row").addClass("hide");
            $('#loadingModal').find(".message, .error").addClass("hide").html("");
            $("button.loading-btn").click();
            $.ajax({
                type: "PUT",
                url: "/sellers/" + $sellerId + "/upload_file",
                data: new FormData($form[0]),
                contentType: false,
                cache: false,
                processData: false,
                success: function(result) {
                    $('#loadingModal').find(".loading-row").addClass("hide");
                    $('#loadingModal').find(".message-row, .button-row").removeClass("hide");
                    if (result.status == 200) {
                        $('#loadingModal').find(".message").removeClass("hide").html(result.message);
                        var $docOjb = result.document;
                        var $document = $(".seller-profile").find(".document-container .clone-card").clone();
                        $document.removeClass("clone-card");
                        $document.attr("docId", $docOjb.id);
                        $document.find(".name").html($docOjb.filename);

                        $(".seller-profile").find(".upload-doc").val(null);

                        if ($docOjb.content_type == "image/png" || $docOjb.content_type == "image/jpeg") {
                            $document.find(".card-body.file").remove();
                            $document.find(".card-body.image").attr("url", $docOjb.url);
                            $document.find(".card-body.image").attr("style", "background-image:url(" + $docOjb.url + "})");
                        }
                        else {
                            $document.find(".card-body.image").remove();
                        }
                        $document.appendTo($(".seller-profile").find(".document-container"));
                    }
                    else {
                        console.log(result.error);
                        $('#loadingModal').find(".error").removeClass("hide").html(result.error);
                    }
                    setTimeout(function() {
                        $('#loadingModal').find(".button-row .btn-confirm").trigger('click');
                    }, 1000);
                },
                error: function(result) {
                }
            });
        });

        $(".seller-profile").on("click", ".remove-doc", function() {
            if (confirm("Are you sure you want to remove document?")) {
                var $sellerId = $(".seller-profile").attr("sellerId");
                var $parent = $(this).parents(".col-md-4:not('.clone-card')");
                var $id = $parent.attr("docId");
                $('#loadingModal').find(".loading-row").removeClass("hide");
                $('#loadingModal').find(".message-row, .button-row").addClass("hide");
                $('#loadingModal').find(".message, .error").addClass("hide").html("");
                $("button.loading-btn").click();
                $.ajax({
                    type: "DELETE",
                    url: "/sellers/" + $sellerId + "/purge_file",
                    data: { doc_id: $id },
                    success: function(result) {
                        console.log(result);
                        $('#loadingModal').find(".loading-row").addClass("hide");
                        $('#loadingModal').find(".message-row, .button-row").removeClass("hide");
                        if (result.status == 200) {
                            // $('#loadingModal').find(".message").removeClass("hide").html(result.message);
                            $parent.remove();
                        }
                        else {
                            // $('#loadingModal').find(".error").removeClass("hide").html(result.error);
                            console.log(result.error);
                        }
                        setTimeout(function() {
                            $('#loadingModal').find(".button-row .btn-confirm").trigger('click');
                            window.location.reload();
                        }, 1000);
                    },
                    error: function(result) {
                        $('#loadingModal').find(".error").removeClass("hide").html(result.error);
                        console.log(result.error);
                    }
                });
            }
        });

        $(".seller-profile").on("click", ".edit-staff", function() {
            setEditStaff();
        });

        $("#editStaff").on("click", ".btn-reset", function() {
            setEditStaff();
        });

        $("#editStaff").on("click", ".btn-update", function() {
            let $editStaff = $("#editStaff");

            $editStaff.find("form, .main-buttons-row").addClass("hide");
            $editStaff.find(".loading-row").removeClass("hide");
            console.log("here update form", $editStaff.find("form")[0])
            $.ajax({
                type: "PUT",
                url: "/admins/update_staff",
                data: new FormData($editStaff.find("form")[0]),
                contentType: false,
                cache: false,
                processData: false,
                success: function(result) {
                    $editStaff.find(".loading-row").addClass("hide");
                    $editStaff.find("form, .message-row, .main-buttons-row").removeClass("hide");
                    if (result.status == 200) {
                        $editStaff.find(".message").removeClass("hide").html(result.message);

                        $editStaff.find('.modal-header button.close').toggle();
                        window.location.reload();
                    }
                    else {
                        $editStaff.find(".error").removeClass("hide").html(result.error);
                    }
                }
            });
        });

        $("#editStaff").on("change", ".upload-user-profile", function() {
            console.log('image upload trigger 3');
            readURL(this, $("#editStaff").find(".image-container .image"));
        });

        $("#editStaff").on('keypress', '.phone_number, .landline', function(e) {
            if (e.which != 8 && e.which != 0 && e.which < 48 || e.which > 57) {
                e.preventDefault();
            }
        });

        function setEditStaff() {
            let $focused = $sellerContacts.find(".image.focused");
            let $contactStaff = $sellerContacts.find(".contact-information[staff_id=" + $focused.attr("staff_id") + "]");
            let $editStaff = $("#editStaff");
            $editStaff.find("input.name").val($contactStaff.find(".first_name").html() + " " + $contactStaff.find(".last_name").html());
            $editStaff.find("input.firstName").val($contactStaff.find(".first_name").html());
            $editStaff.find("input.lastName").val($contactStaff.find(".last_name").html());

            $editStaff.find(".staff-id").val($focused.attr("sf_id"));

            let inputArr = [".department", ".landline", ".phone_number", ".street", ".town", ".city", ".province"];

            $.each(inputArr, function(k, val) {
                $editStaff.find("input" + val).val($contactStaff.find(val).html());
            });

            if ($contactStaff.find(".profile_image").attr("value").trim() != "empty")
                $editStaff.find(".image-container .image").attr("src", $contactStaff.find(".profile_image").attr("value"));
            else
                $editStaff.find(".image-container .image").attr("src", "");
        }

        $("#editPayment").on("click", ".btn-update", function() {
            let $editPayment = $("#editPayment");
            let $sellerId = $(".seller-profile").attr("sellerId");

            $editPayment.find("form, .main-buttons-row").addClass("hide");
            $editPayment.find(".loading-row").removeClass("hide");
            $.ajax({
                type: "PUT",
                url: "/sellers/" + $sellerId + "/update_payment",
                data: new FormData($editPayment.find("form")[0]),
                contentType: false,
                cache: false,
                processData: false,
                success: function(result) {
                    $editPayment.find(".loading-row").addClass("hide");
                    $editPayment.find("form, .message-row, .main-buttons-row").removeClass("hide");
                    if (result.status == 200) {
                        $editPayment.find(".message").removeClass("hide").html(result.message);

                        $editPayment.find('.modal-header button.close').toggle();
                        // window.location.reload();
                        window.location.href = "/profile";
                    }
                    else {
                        $editPayment.find(".error").removeClass("hide").html(result.error);
                    }
                }
            });
        });

        $("#editPayment").on("click", ".btn-reset", function() {
            var $parent = $(this).parents(".modal-body");
            $parent.find("form").find("input").each(function() {
                var $this = $(this);
                $this.val($this.attr("default_value"));
            });
        });

        $('#editPayment').on('keypress', '.bank-account-number', function(e) {
            if (e.which != 8 && e.which != 0 && e.which < 48 || e.which > 57) {
                e.preventDefault();
            }
        });

        function readURL(input, container) {
            if (input.files && input.files[0]) {
                var reader = new FileReader();

                reader.onload = function(e) {
                    container.attr('src', e.target.result);
                    $("#createCategory").find(".image-container").removeClass("hide");
                    $("#createCategory").find(".image-button").addClass("hide");
                }

                reader.readAsDataURL(input.files[0]);
            }
        }
    }

    if ($(".admin-sellers").length) {
        $(".admin-sellers").on("keypress", ".search-sellers", function(e) {
            if (e.key == "Enter") {
                var search_text = $(this).val();
                var url = "/sellers.js"
                if (search_text != "") {
                    if ($(".seller-status").length) {
                        url = url + "?status=" + $(".seller-status").val() + "&search=" + search_text;
                    }
                    else {
                        url = url + "?search=" + search_text;
                    }
                    // window.location.href = url;
                }
                else {
                    if ($(".seller-status").length) {
                        url = url + "?status=" + $(".seller-status").val();
                    }
                }
                $.ajax({
                    type: "GET",
                    url: url,
                    data: { "type": "admin-dashboard" },
                    success: function(result) {
                        console.log(url)
                        window.history.pushState('data', title, url);
                    }
                });
            }
        });

        $(".admin-sellers").on("click", ".send-invitation-button", function() {
            var $popup = $(".invitation-popup");
            $popup.find(".loading-seller.whirl.no-overlay, .buttons.confirm, .message, .error").addClass("hide");
            $popup.find(".invitation-text, .buttons.main").removeClass("hide");
            $popup.find(".message, .error").html("");
            $popup.show();
            $popup.css("height", $(document).height() - 10);
            $popup.find(".invitation-text span").html($(this).parents("tr").find(".email").html());
            $popup.find(".id").attr("value", $(this).parents("tr").find(".email").attr("id"));
        });

        $(".invitation-popup").on("click", ".btn-send", function() {
            var $popup = $(".invitation-popup");
            $popup.find(".loading-seller.whirl.no-overlay").removeClass("hide");
            $popup.find(".invitation-text, .buttons.main").addClass("hide");
            $.ajax({
                type: "POST",
                url: "/sellers/send_invitation",
                data: { id: $(".invitation-popup").find(".id").attr("value") },
                success: function(result) {
                    if (result.status != 300) {
                        $popup.find(".message").html(result.message);
                        $popup.find(".message").removeClass("hide");
                    }
                    else {
                        $popup.find(".error").html(result.error);
                        $popup.find(".error").removeClass("hide");
                    }
                    $popup.find(".buttons.confirm").removeClass("hide");
                    $popup.find(".whirl.no-overlay").addClass("hide");
                }
            });
        });

        $(document).on("click", ".btn-invite", function() {
            var $popup = $("#inviteSeller");
            $popup.find(".email-address").val("");
            $popup.find(".email-address").get(0).focus();
            $popup.find(".loading-invite.whirl.no-overlay").addClass("hide");
            $popup.find(".buttons-row").removeClass("hide");
            $popup.find(".message, .error").html("");
            $popup.find(".message, .error, .btn-confirm").addClass("hide");
            $popup.find(".btn-send-invitation, .btn-cancel").removeClass("hide");
        });

        $("#inviteSeller").on("keypress", ".email-address", function(e) {
            $(this).removeClass("error-form");
            if (e.key == "Enter") {
                if ($(this).val() != "") {
                    $("#inviteSeller").find(".btn-send-invitation").trigger("click");
                }
            }
        });

        $("#inviteSeller").on("click", ".btn-send-invitation", function() {
            var $popup = $("#inviteSeller");
            $popup.find(".error-message").html("").addClass("hide");
            $popup.find(".email-address").removeClass("error-form");
            if ($popup.find(".email-address").val() == "") {
                $popup.find(".error-message").html("Email can't be blank").removeClass("hide");
                $popup.find(".email-address").addClass("error-form")
            }
            else if (!checkEmailFormat($popup.find(".email-address").val())) {
                $popup.find(".error-message").html("Invalid email input").removeClass("hide");
                $popup.find(".email-address").addClass("error-form")
            }
            else {
                $popup.find(".loading-invite.whirl.no-overlay").removeClass("hide");
                $popup.find(".buttons-row").addClass("hide");
                $popup.find(".message, .error").html("");
                $.ajax({
                    type: "POST",
                    url: "/sellers/send_seller_invitation",
                    data: { email: $popup.find(".email-address").val() },
                    success: function(result) {
                        if (result.status != 300) {
                            $popup.find(".message").html(result.message);
                            $popup.find(".message, .btn-confirm").removeClass("hide");
                            $popup.find(".btn-send-invitation, .btn-cancel").addClass("hide");

                            setTimeout(function() {
                                $popup.find(".btn-confirm").trigger("click");
                            }, 1000);
                        }
                        else {
                            $popup.find(".error").html(result.error);
                            $popup.find(".error").removeClass("hide");
                            $popup.find(".btn-send-invitation, .btn-cancel").removeClass("hide");
                        }
                        $popup.find(".buttons-row").removeClass("hide");
                        $popup.find(".whirl.no-overlay").addClass("hide");
                    }
                });
            }
        });

        $(".invitation-popup").on("click", ".btn-cancel, .btn-ok", function() {
            $(".invitation-popup").hide();
        });

        $(".admin-sellers").on("click", ".seller-row .btn-reset", function() {
            let $popup = $("#resetSellerPassword");
            $popup.find(".main-buttons-row").removeClass("hide");
            $popup.find(".btn-reset").attr("sellerId", $(this).attr("sellerId"));
            $popup.find(".seller-info input.my-2").val("");
            $popup.find(".error, .message").html("");
        });

        $("#resetSellerPassword").on("click", ".btn-reset", function() {
            var $this = $(this);
            var $popup = $this.parents(".modal-body");
            var $sellerId = $this.attr("sellerId");
            var $form = $popup.find("form");
            $popup.find(".loading-row").removeClass("hide");
            $popup.find("button.close").css("visibility", "hidden");
            $popup.find(".message-row, .message, .error, .main-buttons-row").addClass("hide");
            $popup.find(".error, .message").html("");
            $.ajax({
                type: "PUT",
                url: "/sellers/" + $sellerId + "/reset_password",
                data: new FormData($form[0]),
                contentType: false,
                cache: false,
                processData: false,
                success: function(result) {
                    $popup.find("button.close").css("visibility", "visible");
                    $popup.find(".loading-row").addClass("hide");
                    if (result.status == 200) {
                        $popup.find(".message-row, .message").removeClass("hide");
                        $popup.find(".message-row .message").html(result.message);

                        setTimeout(function() {
                            $popup.find(".btn-cancel").trigger("click");
                        }, 1000);
                    }
                    else {
                        $popup.find(".message-row, .error").removeClass("hide");
                        $popup.find(".message-row .error").html(result.error);
                        $popup.find(".main-buttons-row").removeClass("hide");
                    }
                },
                error: function(result) {
                }
            });
        });

        $(".admin-sellers").on("click", ".seller-row .btn-reject", function() {
            $("#rejectSeller").find(".reject-btn").attr("sellerId", $(this).attr("store_details_id"));
        });

        $(".admin-sellers").on("click", ".seller-row .btn-delete", function() {
            $("#deleteSeller").find(".reject-btn").attr("sellerId", $(this).attr("store_details_id"));
        });

        $("#rejectSeller").on("click", ".reject-btn", function() {
            var $sellerId = $(this).attr("sellerId");
            var $content = $(this).parents(".reject-content");
            $content.find(".loading-div").removeClass("hide");
            $content.find(".main-buttons-row").addClass("hide");
            $.ajax({
                type: "PUT",
                url: "/sellers/" + $sellerId + "/reject",
                data: { is_admin: true, reject_reason: $content.find("select").val(), reject_notes: $content.find("textarea").val() },
                success: function(result) {

                    $content.find(".loading-div").addClass("hide");
                    if (result.status == 200) {
                        $content.find(".message-row, .message, .confirm-button-row").removeClass("hide");
                        $content.find(".message-row .message").html(result.message);
                    }
                    else {
                        $content.find(".message-row, .error, .main-buttons-row").removeClass("hide");
                        $content.find(".message-row .error").html(result.error)
                    }
                },
                error: function(result) {
                }
            });
        });

        $("#deleteSeller").on("click", ".reject-btn", function() {
            var $sellerId = $(this).attr("sellerId");
            var $content = $(this).parents(".reject-content");
            $content.find(".loading-div").removeClass("hide");
            $content.find(".main-buttons-row").addClass("hide");
            $.ajax({
                type: "PUT",
                url: "/sellers/" + $sellerId + "/delete",
                data: { is_admin: true },
                success: function(result) {

                    $content.find(".loading-div").addClass("hide");
                    if (result.status == 200) {
                        $content.find(".message-row, .message").removeClass("hide");
                        $content.find(".message-row .message").html(result.message);

                        setTimeout(function() {
                            $content.find(".confirm-button-row .btn-confirm").trigger("click");
                        }, 1000);
                    }
                    else {
                        $content.find(".message-row, .error, .main-buttons-row").removeClass("hide");
                        $content.find(".message-row .error").html(result.error)
                    }
                },
                error: function(result) {
                }
            });
        });

        $("#rejectSeller").on("click", ".btn-confirm", function() {
            window.location.reload();
        });

        $(".admin-sellers").on("click", ".seller-row .btn-deactivate", function() {
            $("#deactivateSeller").find(".deactivate-btn").attr("sellerId", $(this).attr("store_details_id"));
        });

        $(".admin-sellers").on("click", ".seller-row .btn-reactivate", function() {
            $("#reactivateSeller").find(".reactivate-btn").attr("sellerId", $(this).attr("store_details_id"));
        });

    }

    if ($(".register-seller").length) {
        $(".aside-container, .topnavbar-wrapper, .offsidebar").remove();
        $(".register-seller").css({
            "height": $(document).height() - 60
        });
        $(".wrapper").css({
            "height": "100vh",
            "min-height": "100vh",
            "overflow-y": "hidden"
        });
        $(".section-container").addClass("section-register");

        $(".register-seller").on("change", ".checkbox input", function() {
            if ($(this).is(":checked")) {
                $(".register-seller").find(".register-button").removeClass("disabled");
            }
            else {
                $(".register-seller").find(".register-button").addClass("disabled");
            }
        });
        $(".register-seller").on("keypress", ".input-phone", function(e) {
            let inputValue = $(this).val();

            if (inputValue.startsWith("63")) {
                if (inputValue.replace(/\D+/g, "").length >= 12) {
                    e.preventDefault();
                }
            } else {
                if (inputValue.replace(/\D+/g, "").length >= 11) {
                    e.preventDefault();
                }
            }
        });
        function validateAndFormatPhoneNumber(inputElement) {
            let phoneNumber = inputElement.val().replace(/\D+/g, "");
            let errorElement = $("#mobile-number-error-message");

            function detectCountry(phone) {
                if (phone.startsWith("1") && phone.length === 11) return "ca";
                if (phone.startsWith("09") && phone.length >= 11) return "ph";
                if (phone.startsWith("63") && phone.length >= 12) return "ph";
                return null;
            }

            function formatPhoneNumber(phone, country) {
                let formattedNumber = "";

                if (!phone) return phone;

                switch (country) {
                    case "us":
                    case "ca":
                        if (phone.startsWith("1") && phone.length === 11) {
                            phone = phone.substring(1);
                        }
                        formattedNumber += `+1 `
                        if (phone.length >= 3) formattedNumber += `(${phone.substring(0, 3)}`; // Area code
                        if (phone.length >= 6) formattedNumber += `) ${phone.substring(3, 6)}`; // Prefix
                        if (phone.length >= 10) formattedNumber += `-${phone.substring(6, 10)}`; // Line number
                        break;

                    case "ph":
                        if (phone.startsWith("09") && phone.length === 11) {
                            phone = "63" + phone.substring(1);
                        }

                        if (phone.startsWith("63") && phone.length >= 12) {
                            formattedNumber += `+${phone.substring(0, 2)} `;
                            formattedNumber += `${phone.substring(2, 5)} `;
                            formattedNumber += `${phone.substring(5, 8)} `;
                            formattedNumber += `${phone.substring(8, 12)}`;
                        } else {
                            formattedNumber = phone;
                        }
                        break;

                    default:
                        formattedNumber = phone;
                }

                return formattedNumber.trim();
            }

            let detectedCountry = detectCountry(phoneNumber);
            let formattedNumber = formatPhoneNumber(phoneNumber, detectedCountry);

            if (formattedNumber !== inputElement.val()) {
                inputElement.val(formattedNumber);
            }

            let phonePatterns = {
                us: /^(\+1\s?)?(\(?\d{3}\)?)[\s.-]?(\d{3})[\s.-]?(\d{4})$/,
                ca: /^(\+1\s?)?(\(?\d{3}\)?)[\s.-]?(\d{3})[\s.-]?(\d{4})$/,
                ph: /^\+63\s?\d{3}\s\d{3}\s\d{4}$/
            };

            let valid = detectedCountry && phonePatterns[detectedCountry]?.test(formattedNumber);

            if (valid) {
                errorElement.addClass("hide");
            } else {
                errorElement.removeClass("hide");
            }
        }

        $(".register-seller").on("input change", ".input-phone", function() {
            validateAndFormatPhoneNumber($(this));
        });
        $(".register-seller").on("click", ".register-button:not(.disabled)", function() {
            console.log("initiate register seller");
            var $newUser = $("#new_user");
            var $storeDetail = {
                countries: [],
                business_name: "",
                owner_name: "",
                product_types: "",
                bank_type: "",
                bank_account_number: "",
                mobile_number: "",
                email: ""
            };
            var isValid = true;
            $newUser.find("input:not(.input-checkbox)").each(function(e) {
                $(this).removeClass("error-input");
                $(this).parents(".row").find(".error-message").addClass("hide");
                $(this).parents(".row").find(".error-message").html("");
                if ($(this).attr("key") != undefined) {
                    var value = $(this).val();
                    if (value != "") {
                        value = $(this).attr("key") != "product_types" ? value : value.split(',');
                        $storeDetail[$(this).attr("key")] = value;
                    }
                    else {
                        isValid = false;
                        $(this).addClass("error-input");
                        $(this).parents(".row").find(".error-message").removeClass("hide");
                        $(this).parents(".row").find(".error-message").html("This field must not be empty");
                    }
                }
                if ($(this).attr("key") == "email") {
                    if (checkEmailFormat($(this).val()) == false) {
                        isValid = false;
                        $(this).addClass("error-input");
                        $(this).parents(".row").find(".error-message").removeClass("hide");
                        $(this).parents(".row").find(".error-message").html("Invalid email input");
                    }
                }
                if ($(this).attr("key") == "mobile_number") {
                    validateAndFormatPhoneNumber($(this));

                    let phoneNumber = $(this).val();
                    let errorElement = $(this).parents(".row").find(".error-message");

                    let phonePatterns = {
                        us: /^(\+1\s?)?(\(?\d{3}\)?)[\s.-]?(\d{3})[\s.-]?(\d{4})$/,
                        ca: /^(\+1\s?)?(\(?\d{3}\)?)[\s.-]?(\d{3})[\s.-]?(\d{4})$/,
                        ph: /^\+63\s?\d{3}\s\d{3}\s\d{4}$/
                    };

                    function detectCountry(phone) {
                        if (phone.startsWith("+1")) return "us";
                        if (phone.startsWith("+63")) return "ph";
                        return null;
                    }

                    let detectedCountry = detectCountry(phoneNumber);
                    let valid = detectedCountry && phonePatterns[detectedCountry]?.test(phoneNumber);

                    if (phoneNumber.length === 0) {
                        errorElement.removeClass("hide").html("Mobile number is required");
                        isValid = false;
                    } else if (valid) {
                        errorElement.addClass("hide");
                    } else {
                        errorElement.removeClass("hide").html("Invalid format");
                        isValid = false;
                    }
                }

            });
            $storeDetail["product_types"] = $('.product-types').val()
            $storeDetail["bank_type"] = $newUser.find(".custom-select").val();
            $storeDetail["countries"][0] = $(".country-select").val();
            if (isValid) {
                console.log('product types', $storeDetail["product_types"]);
                $(".register-container").addClass("hide");
                $(".whirl.no-overlay").removeClass("hide");
                $.ajax({
                    type: "POST",
                    url: "/sellers/",
                    data: { store_detail: $storeDetail },
                    success: function(result) {
                        $(".whirl.no-overlay").addClass("hide");
                        if (result.status == 200) {
                            $(".register-background").addClass("hide")
                            $(".success-container").removeClass("hide");
                        }
                        else {
                            $(".register-container").removeClass("hide");
                            if (result.email != undefined) {
                                $newUser.find(".email-row .error-message").html(result.email);
                                $newUser.find(".email-row .error-message").removeClass("hide")
                                $newUser.find("#mobile-number-error-message .error-message").removeClass("hide");;
                                $newUser.find(".email-row input").addClass("error-input");
                            }
                        }
                    },
                    error: function(result) {
                    }
                });
            }
        });

        $(".small-screen").on("click", ".register-button:not(.disabled)", function() {
            var $newUser = $("#new_user_mobile");
            var $storeDetail = {
                business_name: "",
                owner_name: "",
                product_types: "",
                bank_type: "",
                bank_account_number: "",
                mobile_number: "",
                email: ""
            };
            var isValid = true;
            $newUser.find("input:not(.input-checkbox)").each(function(e) {
                $(this).removeClass("error-input");
                $(this).parents(".row").find(".error-message").addClass("hide");
                $(this).parents(".row").find(".error-message").html("");
                if ($(this).attr("key") != undefined) {
                    var value = $(this).val();
                    if (value != "" || value.length > 0) {
                        value = $(this).attr("key") != "product_types" ? value : value.split(',');
                        $storeDetail[$(this).attr("key")] = value;
                    }
                    else {
                        isValid = false;
                        $(this).addClass("error-input");
                        $(this).parents(".row").find(".error-message").removeClass("hide");
                        $(this).parents(".row").find(".error-message").html("This field must not be empty");
                    }
                }
            });
            $storeDetail["product_types"] = $('.product-types').val()
            $storeDetail["bank_type"] = $newUser.find(".custom-select").val();

            if (isValid) {
                $(".register-container").addClass("hide");
                $(".whirl.no-overlay").removeClass("hide");
                $.ajax({
                    type: "POST",
                    url: "/sellers/",
                    data: { store_detail: $storeDetail },
                    success: function(result) {
                        $(".whirl.no-overlay").addClass("hide");
                        if (result.status == 200) {
                            $(".register-background").addClass("hide")
                            $(".success-container").removeClass("hide");
                        }
                        else {
                            $(".register-container").removeClass("hide");
                            if (result.email != undefined) {
                                $newUser.find(".email-row .error-message").html(result.email);
                                $newUser.find(".email-row .error-message").removeClass("hide");
                                $newUser.find(".email-row input").addClass("error-input");
                            }
                        }
                    },
                    error: function(result) {
                    }
                });
            }
        });

        $(".product-types").select2({
            theme: 'bootstrap4',
            tags: true,
            placeholder: "Select Categories",
            tokenSeparators: [',', ' '],
            createTag: function() {
                return null;
            }
        });

        $(".register-seller").on("keypress", ".input-owner-name", function() {
            return lettersOnly(this);
        });
    }
    var isValid = false;
    if ($(".register-agent").length) {
        $("input[name='company[email]']").on("change", function(e) {

            var email = $(this).val()
            var regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
            var errorMessage = $('.email-row.agent-row').find('.error-message');
            if (email == '') {
                console.log('Invalid email input')
                errorMessage.removeClass('hide')
                errorMessage.html('Email is required.')
                isValid = false;
            }
            else if (regex.test(email)) {
                console.log('Valid email input');
                errorMessage.addClass('hide')
                isValid = true;
            }
            else {
                console.log('Invalid email input')
                errorMessage.removeClass('hide')
                errorMessage.html('Invalid email input')
                isValid = false;
            }
        })
        $(".aside-container, .topnavbar-wrapper, .offsidebar").remove();
        // $(".register-agent").css({
        //   "height": $(document).height()
        // });
        $(".section-container").addClass("section-register");

        $(".register-agent").on("change", ".checkbox input", function() {
            if ($(this).is(":checked")) {
                $(".register-agent").find(".register-button").removeClass("disabled");
            }
            else {
                $(".register-agent").find(".register-button").addClass("disabled");
            }
        });

        $(".register-agent").on("click", ".register-button:not(.disabled)", function() {
            var $newUser = $("#new_user");
            var isValid = true;
            var userType = $('#userType').attr('value')
            console.log('userType value: ', userType)
            $newUser.find("input:not(.input-checkbox)").each(function(e) {
                $(this).removeClass("error-input");
                $(this).parents(".agent-row").find(".error-message").addClass("hide");
                $(this).parents(".agent-row").find(".error-message").html("");
                if ($(this).attr("key") != undefined) {
                    var value = $(this).val();
                    if (value == "" || value.length == 0) {
                        isValid = false;
                        $(this).addClass("error-input");
                        $(this).parents(".agent-row").find(".error-message").removeClass("hide");
                        $(this).parents(".agent-row").find(".error-message").html("This field must not be empty");
                    }
                }
                if ($(this).attr("key") == 'email') {
                    if (checkEmailFormat($(this).val()) == false) {
                        isValid = false;
                        $(this).addClass("error-input");
                        $(this).parents(".row").find(".error-message").removeClass("hide");
                        $(this).parents(".row").find(".error-message").html("Invalid email input");
                    }
                }
            });

            if (isValid) {
                $(".register-container").addClass("hide");
                $(".whirl.no-overlay").removeClass("hide");
                $.ajax({
                    type: "POST",
                    url: userType === 'agent' ? "/agents/" :
                        userType == 'courier' ? "/couriers/" :
                            userType == 'seller' ? "/sellers/" : "/agents/",
                    data: new FormData($newUser[0]),
                    contentType: false,
                    cache: false,
                    processData: false,
                    success: function(result) {
                        $(".whirl.no-overlay").addClass("hide");
                        if (result.status == 200) {
                            $(".success-container").removeClass("hide");
                        }
                        else {
                            $(".register-container").removeClass("hide");
                            if (result.email != undefined) {
                                $newUser.find(".email-row .error-message").html(result.email);
                                $newUser.find(".email-row .error-message").removeClass("hide");
                                $newUser.find(".email-row input").addClass("error-input");
                            } else {
                                console.log(result.error)
                            }
                        }
                    },
                    error: function(result) {
                    }
                });
            }
        });

        $(".small-screen").on("click", ".register-button:not(.disabled)", function() {
            var $newUser = $("#new_user_mobile");
            console.log($newUser)
            var isValid = true;
            var userType = $(document).find('#userType').val();
            $newUser.find("input:not(.input-checkbox)").each(function(e) {
                console.log(this)
                $(this).removeClass("error-input");
                $(this).parents(".agent-row").find(".error-message").addClass("hide");
                $(this).parents(".agent-row").find(".error-message").html("");
                if ($(this).attr("key") != undefined) {
                    var value = $(this).val();
                    if (value == "") {
                        isValid = false;
                        $(this).addClass("error-input");
                        $(this).parents(".agent-row").find(".error-message").removeClass("hide");
                        $(this).parents(".agent-row").find(".error-message").html("This field must not be empty");
                    }
                }
            });

            if (isValid) {
                $(".register-container").addClass("hide");
                $(".whirl.no-overlay").removeClass("hide");
                $.ajax({
                    type: "POST",
                    url: userType === 'agent' ? "/agents/" :
                        userType == 'courier' ? "/couriers/" :
                            userType == 'seller' ? "/sellers/" : "/agents/",
                    data: new FormData($newUser[0]),
                    contentType: false,
                    cache: false,
                    processData: false,
                    success: function(result) {
                        $(".whirl.no-overlay").addClass("hide");
                        if (result.status == 200) {
                            $(".success-container").removeClass("hide");
                        }
                        else {
                            $(".register-container").removeClass("hide");
                            if (result.email != undefined) {
                                $newUser.find(".email-row .error-message").html(result.email);
                                $newUser.find(".email-row .error-message").removeClass("hide");
                                $newUser.find(".email-row input").addClass("error-input");
                            } else {
                                console.log(result.error)
                            }
                        }
                    },
                    error: function(result) {
                    }
                });
            }
        });
    }

    if ($(".new-seller").length) {
        $(".aside-container, .topnavbar-wrapper, .offsidebar").remove();
        $(".section-container").addClass("section-seller-register");

        if ($(".is_rejected").length) {
            if ($(".is_rejected").attr("value") == "true") {
                $(document).find("form input").attr("disabled", "disabled");
            }
        }

        $(document).on('submit', 'form', function(e) {
            let isValid = true;
            let message = "";
            $(".main-password").find(".error").addClass("hide").html("");
            let $mainPassword = $(".main-password").find("input").val().trim();
            let $confirmPassword = $(".confirm-password").find("input").val().trim();

            if ($mainPassword.length < 8) {
                isValid = false;
                message = "Password must be at least 8 characters.";
            }
            else if ($mainPassword != $confirmPassword) {
                isValid = false;
                message = "Password does not match.";
            }

            if (isValid) {
                $("button.loading-btn").click();
            }
            else {
                $(".main-password").find(".error").removeClass("hide").html(message);
            }
            return isValid;
        });

        if ($(".register-seller-token").length) {
            $(document).on("mouseenter", ".fa-eye", function() {
                let $parent = $(this).parents(".form-group");
                $parent.find("input").attr("type", "text");
            });
            $(document).on("mouseleave", ".fa-eye", function() {
                let $parent = $(this).parents(".form-group");
                $parent.find("input").attr("type", "password");
            });
        }
    }

    if ($(".forgot_password").length) {
        $(".forgot_password").on("click", ".btn-submit", function() {
            if ($(".forgot_password").find(".user-email").val() != "" && checkEmailFormat($(".forgot_password").find(".user-email").val())) {
                //  $('#loadingModal').find(".loading-row").removeClass("hide");
                //  $('#loadingModal').find(".message-row, .button-row").addClass("hide");
                // $('#loadingModal').find(".message, .errir").addClass("hide").html("");
                $("button.loading-btn").click();

                $.ajax({
                    type: "PUT",
                    url: "/sellers/send_reset_token",
                    data: { email: $(".forgot_password").find(".user-email").val() },
                    success: function(result) {
                        $('#loadingModal').find(".loading-row").addClass("hide");
                        $('#loadingModal').find(".message-row, .button-row").removeClass("hide");
                        $('.error-message').addClass("hide").text("");
                        if (result.status == 200) {

                            $('#loadingModal').find(".loading-row").addClass("hide");
                            $('#loadingModal').find(".message").removeClass("hide").html(result.message);
                            $('#loadingModal').find(".btn-confirm").addClass("hide");
                            $("#loadingModal").find(".btn-redirect").removeClass("hide");
                        }
                        else {
                            $('#loadingModal').addClass('hide');
                            // $('#loadingModal').find(".error").removeClass("hide").html(result.error);
                        }
                    },
                    error: function(xhr) {
                        $('#loadingModal').addClass('hide');
                        var json = xhr && xhr.responseJSON;
                        var msg = (json && (json.error || json.errorMessage || json.message)) || xhr.statusText || 'Request failed';
                        $('.error-message').removeClass("hide").text(msg);
                    }
                });
            } else {
                console.log($("forgot_password").find(".user-email").val())
                $('.error-message').removeClass("hide").html(($("forgot_password").find(".user-email").val() == "" || $("forgot_password").find(".user-email").val() == null) ? "Email is required" : "Invalid email input")
            }
        });

        $("#loadingModal").on("click", ".btn-redirect", function() {
            window.location.href = "/sign_in"
        });
    }

    if ($(".seller-reset-password").length) {
        $(".seller-reset-password").on("click", ".btn-submit", function(e) {
            e.preventDefault();
            if ($(".forgot_password").find(".user-email").val() != "") {
                $("button.loading-btn").click();
                var $popup = $('#loadingModal');
                $popup.find(".error, .message").html("");
                var $form = $(".seller-reset-password").find("form");

                $.ajax({
                    type: "PUT",
                    url: "/sellers/set_seller_password",
                    data: new FormData($form[0]),
                    contentType: false,
                    cache: false,
                    processData: false,
                    success: function(result) {
                        console.log("status " + result.status)
                        $popup.find(".loading-row").addClass("hide");
                        $popup.find(".message-row, .button-row").removeClass("hide");

                        if (result.status == 200) {
                            $popup.find(".message").removeClass("hide").html(result.message);
                            $popup.find(".btn-confirm").addClass("hide");
                            $popup.find(".btn-redirect").removeClass("hide");
                        }
                        else {
                            $popup.find(".error").removeClass("hide").html(result.error);
                        }
                    },
                    error: function(result) {
                    }
                });
            }
        });

        $("#loadingModal").on("click", ".btn-redirect", function() {
            window.location.href = "/sign_in"
        });
    }

    if ($(".show-seller").length) {
        $(".show-seller").on("click", ".edit-popup-btn", function() {
            var $popup = $(".edit-seller-popup");
            $popup.find(".loading-div, .message-row, .message, .error, .confirm-button-row").addClass("hide");
            $popup.find(".main-buttons-row, .content-row").removeClass("hide");
            $popup.find(".error, .message").html("");
        });

        $(".show-seller").on("click", ".reject-btn-popup", function() {
            var $content = $("#rejectSeller").find(".reject-content");
            $content.find(".loading-div, .message-row, .message, .error, .confirm-button-row").addClass("hide");
            $content.find(".main-buttons-row").removeClass("hide");
            $content.find(".error, .message").html("");
        });

        $(".show-seller").on("click", ".document", function() {
            var $parent = $(this);
            var $content = $("#documentPopup");

            $content.find(".loading-row").removeClass("hide");
            $content.find(".image-row").addClass("hide");
            $content.find(".modal-title").html($parent.find(".name").html());
            $content.find(".image-row img").attr("src", $parent.find(".image").attr("url"));
        });

        $(".edit-seller-popup").on("click", ".btn-update", function() {
            console.log('method 2 called')
            var $sellerInfo = $(this).parents(".edit-seller-popup").find(".seller-info");
            var $sellerId = $(this).parents(".edit-seller-popup").attr("sellerId");
            var $obj = {};
            var variables = [];
            var $popup = $sellerInfo.parents(".edit-seller-popup");

            $popup.find(".loading-div").removeClass("hide");
            $popup.find(".main-buttons-row, .content-row").addClass("hide");

            $sellerInfo.find("input").each(function() {
                $obj[$(this).attr("name") + ""] = $(this).val();
                variables.push($(this).attr("name") + "");
            });
            $sellerInfo.find("textarea").each(function() {
                $obj[$(this).attr("name") + ""] = $(this).val();
                variables.push($(this).attr("name") + "");
            });

            if ($(this).parents(".edit-seller-popup").hasClass("bank-popup")) {
                $obj["bank_id"] = parseInt($(this).parents(".edit-seller-popup").find(".bank-type-select").val());
                variables.push("bank_id");
            }

            $.ajax({
                type: "PUT",
                url: "/sellers/" + $sellerId + "/update_info",
                data: { store_detail: $obj, is_admin: true },
                success: function(result) {
                    $popup.find(".main-buttons-row, .content-row").addClass("hide");
                    $popup.find(".content-row").removeClass("hide");
                    $popup.find(".loading-div").addClass("hide");
                    if (result.status == 200) {
                        $.each(variables, function(index, variable) {
                            console.log(".show-" + variable + ": " + $obj[variable])
                            $(".show-seller").find(".show-" + variable).html($obj[variable]);
                        });
                        if ($popup.hasClass("bank-popup")) {
                            $(".show-seller").find(".show-bank_type").html($popup.find(".bank-type-select option[value=" + $obj["bank_id"] + "]").html())
                        }
                        $popup.find(".message-row, .message, .confirm-button-row").removeClass("hide")
                        $popup.find(".message-row .message").html(result.message);
                    }
                    else {
                        $popup.find(".message-row, .error, .main-buttons-row").removeClass("hide")
                        $popup.find(".message-row .error").html(result.error);
                    }
                },
                error: function(result) {
                }
            });
        });


        let $adminContainer = $(".admin-notes-container");
        $(".show-seller").on("change", ".admin-notes", function() {
            var $sellerId = $(".show-seller").attr("storeId");
            let $this = $(this);
            $.ajax({
                type: "PUT",
                url: "/sellers/" + $sellerId + "/update_admin_info",
                data: { notes: $this.val(), is_admin: true },
                success: function(result) {
                    $adminContainer.find(".fa-check-circle").attr("style", "color:#27c24c;");
                },
                error: function(result) {
                }
            });
        });

        $(".show-seller").on("keyup", ".admin-notes", function() {
            $adminContainer.find(".fa-check-circle").removeAttr("style");
        });

        $(".show-seller").on("click", ".approve-btn", function() {
            var $sellerId = $(".show-seller").attr("storeId");
            var $parent = $(this).parents(".buttons-container");
            $parent.find(".loading-row").removeClass("hide");
            $parent.find(".message-row, .message, .error, .main-button").addClass("hide");
            $parent.find(".message, .error").html("");
            $('#loadingModal').find(".loading-row").removeClass("hide");
            $('#loadingModal').find(".message-row, .button-row").addClass("hide");
            $('#loadingModal').find(".message, .errir").addClass("hide").html("");
            $("button.loading-btn").click();

            $.ajax({
                type: "PUT",
                url: "/sellers/" + $sellerId + "/approve",
                data: { is_admin: true },
                success: function(result) {
                    $parent.find(".loading-row").addClass("hide");
                    $parent.find(".message-row, .main-button").removeClass("hide");
                    $('#loadingModal').find(".loading-row").addClass("hide");
                    $('#loadingModal').find(".message-row, .button-row").removeClass("hide");

                    if (result.status == 200) {
                        $('#loadingModal').find(".message").removeClass("hide").html(result.message);
                        $('#loadingModal').find(".btn-confirm").addClass("hide");
                        $("#loadingModal").find(".btn-reload").removeClass("hide");
                        $parent.find(".message").removeClass("hide");
                        $parent.find(".message").html(result.message);
                    }
                    else {
                        $('#loadingModal').find(".error").removeClass("hide").html(result.message);
                        $parent.find(".error").removeClass("hide");
                        $parent.find(".error").html(result.error);
                    }
                },
                error: function(result) {
                }
            });
        });

        $("#loadingModal").on("click", ".btn-reload", function() {
            window.location.reload();
        });

        $("#rejectSeller").on("click", ".reject-btn", function() {
            var $sellerId = $(".show-seller").attr("storeId");
            var $content = $(this).parents(".reject-content");
            $content.find(".loading-div").removeClass("hide");
            $content.find(".main-buttons-row").addClass("hide");
            $.ajax({
                type: "PUT",
                url: "/sellers/" + $sellerId + "/reject",
                data: { reject_reason: $content.find("select").val(), reject_notes: $content.find("textarea").val(), is_admin: true },
                success: function(result) {
                    $content.find(".loading-div").addClass("hide");
                    if (result.status == 200) {

                        $content.find(".message-row, .message, .confirm-button-row").removeClass("hide");
                        $content.find(".message-row .message").html(result.message);
                    }
                    else {
                        $content.find(".message-row, .error, .main-buttons-row").removeClass("hide");
                        $content.find(".message-row .error").html(result.error)
                    }
                },
                error: function(result) {
                }
            });
        });

        $(".show-seller").on("change", ".upload-doc", function() {
            var $val = $(this).val();
            if ($val != null) {
                var $sellerId = $(".show-seller").attr("storeId");
                var $form = $(".show-seller").find(".upload-form");

                $('#loadingModal').find(".loading-row").removeClass("hide");
                $('#loadingModal').find(".message-row, .button-row").addClass("hide");
                $('#loadingModal').find(".message, .errir").addClass("hide").html("");
                $("button.loading-btn").click();
                $.ajax({
                    type: "PUT",
                    url: "/sellers/" + $sellerId + "/upload_file?is_admin=true",
                    data: new FormData($form[0]),
                    contentType: false,
                    cache: false,
                    processData: false,
                    success: function(result) {
                        $('#loadingModal').find(".loading-row").addClass("hide");
                        $('#loadingModal').find(".message-row, .button-row").removeClass("hide");
                        if (result.status == 200) {
                            $('#loadingModal').find(".message").removeClass("hide").html(result.message);
                            var $docOjb = result.document;
                            var $document = $(".show-seller").find(".documents-container .clone-card").clone();
                            $document.removeClass("clone-card");
                            $document.attr("docId", $docOjb.id);
                            $document.find(".name").html($docOjb.filename);

                            $(".show-seller").find(".upload-doc").val(null);

                            if ($docOjb.content_type == "image/png" || $docOjb.content_type == "image/jpeg") {
                                $document.find(".card-body.file").remove();
                                $document.find(".card-body.image").attr("url", $docOjb.url);
                                $document.find(".card-body.image").attr("style", "background-image:url(" + $docOjb.url + "})");
                            }
                            else {
                                $document.find(".card-body.image").remove();
                            }
                            $document.appendTo($(".show-seller").find(".documents-container .row"));
                        }
                        else {
                            console.log(result.error);
                            $('#loadingModal').find(".error").removeClass("hide").html(result.error);
                        }
                        setTimeout(function() {
                            $('#loadingModal').find(".button-row .btn-confirm").trigger('click');
                        }, 1000);
                    },
                    error: function(result) {
                    }
                });
            }
        });

        $(".show-seller").on("click", ".remove-doc", function() {
            var $sellerId = $(".show-seller").attr("storeId");
            var $parent = $(this).parents(".col-lg-4");
            var $id = $parent.attr("docId");
            $.ajax({
                type: "DELETE",
                url: "/sellers/" + $sellerId + "/purge_file",
                data: { doc_id: $id, is_admin: true },
                success: function(result) {
                    if (result.status == 200) {
                        $parent.remove();
                    }
                    else {
                        console.log(result.error);
                    }
                },
                error: function(result) {
                }
            });
        });

        $(".show-seller").on("click", ".deactivate-btn-popup", function() {
            $("#deactivateSeller").find(".deactivate-btn").attr("sellerId", $(this).attr("store_details_id"));
        });

        $(".show-seller").on("click", ".reactivate-btn-popup", function() {
            $("#reactivateSeller").find(".reactivate-btn").attr("sellerId", $(this).attr("store_details_id"));
        });
    }

    if ($(".admin-product-index").length) {
        $("#editSellerProfile").on("click", ".btn-update", function() {
            console.log('method 3 called')
            var $this = $(this);
            var $popup = $(this).parents(".modal-body");
            var $val = $this.val();
            var $sellerId = $(".admin-product-index").attr("sellerId");
            var $form = $popup.find("form");
            $popup.find(".loading-row").removeClass("hide");
            $popup.find("button.close").css("visibility", "hidden");
            $popup.find(".message-row, .message").removeClass("hide");

            // $form.find(".country-input-container").html("");
            // $.each($(".country-select").select2().val(), function (i, val) {
            //   $('<input>').attr({
            //     type: 'hidden',
            //     name: 'store_detail[countries][]',
            //     value: val
            //   }).appendTo($(".country-input-container"));
            // });
            $.ajax({
                type: "PUT",
                url: "/sellers/" + $sellerId + "/update_info",
                data: new FormData($form[0]),
                contentType: false,
                cache: false,
                processData: false,
                success: function(result) {
                    $popup.find("button.close").css("visibility", "visible");
                    $popup.find(".loading-row").addClass("hide");
                    if (result.status == 200) {
                        $form.find("input").each(function() {
                            var $this = $(this);
                            $this.attr("default_value", $this.val());
                            $(".seller-profile").find($this.attr("display")).html($this.val());
                        });
                        $popup.find(".message-row, .message").removeClass("hide");
                        $popup.find(".message-row .message").html(result.message);
                    }
                    else {
                        $popup.find(".message-row, .error").removeClass("hide");
                        $popup.find(".message-row .error").html(result.error);
                    }
                },
                error: function(result) {
                }
            });
        });
    }

    if ($("#documentPopup").length) {
        $("#documentPopup").find(".image-row img")[0].onload = function() {
            $("#documentPopup").find(".loading-row").addClass("hide");
            $("#documentPopup").find(".image-row").removeClass("hide");
        }
    }

    $("#deactivateSeller").on("click", ".deactivate-btn", function() {
        var $sellerId = $(this).attr("sellerId");
        var $content = $(this).parents(".reject-content");
        $content.find(".loading-div").removeClass("hide");
        $content.find(".main-buttons-row").addClass("hide");
        $.ajax({
            type: "PUT",
            url: "/sellers/" + $sellerId + "/deactivate",
            data: { is_admin: true },
            success: function(result) {

                $content.find(".loading-div").addClass("hide");
                if (result.status == 200) {
                    $content.find(".message-row, .message").removeClass("hide");
                    $content.find(".message-row .message").html(result.message);


                    setTimeout(function() {
                        $content.find(".confirm-button-row .btn-confirm").trigger("click");
                    }, 1000);
                }
                else {
                    $content.find(".message-row, .error, .main-buttons-row").removeClass("hide");
                    $content.find(".message-row .error").html(result.error)
                }
            },
            error: function(result) {
            }
        });
    });

    $("#reactivateSeller").on("click", ".reactivate-btn", function() {
        var $sellerId = $(this).attr("sellerId");
        var $content = $(this).parents(".reactivate-content");
        $content.find(".loading-div").removeClass("hide");
        $content.find(".main-buttons-row").addClass("hide");
        $.ajax({
            type: "PUT",
            url: "/sellers/" + $sellerId + "/reactivate",
            data: { is_admin: true },
            success: function(result) {

                $content.find(".loading-div").addClass("hide");
                if (result.status == 200) {
                    $content.find(".message-row, .message").removeClass("hide");
                    $content.find(".message-row .message").html(result.message);

                    setTimeout(function() {
                        $content.find(".confirm-button-row .btn-confirm").trigger("click");
                    }, 1000);
                }
                else {
                    $content.find(".message-row, .error, .main-buttons-row").removeClass("hide");
                    $content.find(".message-row .error").html(result.error)
                }
            },
            error: function(result) {
            }
        });
    });

    $("#verifySeller").on("click", ".verify-btn", function() {
        var $sellerId = $(this).attr("sellerId");
        var $content = $(this).parents(".verify-content");
        $content.find(".loading-div").removeClass("hide");
        $content.find(".main-buttons-row").addClass("hide");
        $.ajax({
            type: "PUT",
            url: "/sellers/" + $sellerId + "/verify",
            data: { is_admin: true },
            success: function(result) {

                $content.find(".loading-div").addClass("hide");
                if (result.status == 200) {
                    $content.find(".message-row, .message, .confirm-button-row").removeClass("hide");
                    $content.find(".message-row .message").html(result.message);
                }
                else {
                    $content.find(".message-row, .error, .main-buttons-row").removeClass("hide");
                    $content.find(".message-row .error").html(result.error)
                }
            },
            error: function(result) {
            }
        });
    });

    $("#deactivateSeller").on("click", ".btn-confirm", function() {
        window.location.reload();
    });

    $("#reactivateSeller").on("click", ".btn-confirm", function() {
        window.location.reload();
    });

    $("#verifySeller").on("click", ".btn-confirm", function() {
        window.location.reload();
    });

    if ($(".admin-product-show").length || $(".admin-product-index").length) {

        $(".product-status").on('click', '.dropdown-menu a', function() {
            var $this = $(this);
            var text = $this.html();
            var htmlText = text + ' <span class="caret"></span>';
            var $status = $this.attr("value");
            var $sellerId = $this.attr("sellerId");
            var $toggle = $this.closest('.dropdown').find('.dropdown-toggle');

            $toggle.prop('disabled', 'disabled');
            $toggle.find("span.title").hide();
            $toggle.find(".loading").show();
            $.ajax({
                type: "PUT",
                url: "/sellers/" + $sellerId + "/set_status",
                data: { status: $status },
                success: function(result) {
                    $toggle.prop('disabled', false);
                    $toggle.removeClass("btn-success btn-danger btn-primary");
                    console.log('status:', $status, typeof $status);
                    $toggle.addClass($status == 0 || $status == '0' ? "btn-success" : ($status === 6 || $status === '6' ? "btn-primary" : "btn-danger"));
                    $toggle.find("span.title").html(htmlText);
                    $toggle.find(".loading").hide();
                    $toggle.find("span.title").show();
                },
                error: function(result) {
                }
            });
        });

        $(document).on("click", ".verify-btn-popup", function() {
            $("#verifySeller").find(".verify-btn").attr("sellerId", $(this).attr("store_details_id"));
        });

        $(document).on("click", ".deactivate-btn-popup", function() {
            $("#deactivateSeller").find(".deactivate-btn").attr("sellerId", $(this).attr("store_details_id"));
        });

        $(document).on("click", ".reactivate-btn-popup", function() {
            $("#reactivateSeller").find(".reactivate-btn").attr("sellerId", $(this).attr("store_details_id"));
        });

        $(document).on("click", ".document .btn-document", function() {
            var $parent = $(this).parents(".document");
            var $content = $("#documentPopup");

            $content.find(".loading-row").removeClass("hide");
            $content.find(".image-row").addClass("hide");
            $content.find(".modal-title").html($parent.find(".name").html());
            $content.find(".image-row img").attr("src", $parent.find(".image").attr("url"));
        });

        $(document).on("change", ".upload-doc", function() {
            var $val = $(this).val();
            var $sellerId = $(this).parents(".documents-section").attr("storeId");
            var $form = $(this).parents(".upload-form");
            var $parent = $(this).parents(".documents-section");

            $('#loadingModal').find(".loading-row").removeClass("hide");
            $('#loadingModal').find(".message-row, .button-row").addClass("hide");
            $('#loadingModal').find(".message, .errir").addClass("hide").html("");
            $("button.loading-btn").click();
            $.ajax({
                type: "PUT",
                url: "/sellers/" + $sellerId + "/upload_file?is_admin=true",
                data: new FormData($form[0]),
                contentType: false,
                cache: false,
                processData: false,
                success: function(result) {
                    $('#loadingModal').find(".loading-row").addClass("hide");
                    $('#loadingModal').find(".message-row, .button-row").removeClass("hide");
                    if (result.status == 200) {
                        $('#loadingModal').find(".message").removeClass("hide").html(result.message);
                        var $docOjb = result.document;
                        var $document = $parent.find(".documents-container .document.clone").clone();
                        $document.removeClass("clone hide");
                        $document.find(".name").html($docOjb.filename);

                        if ($docOjb.content_type == "image/png" || $docOjb.content_type == "image/jpeg") {
                            $document.find(".image").attr("url", $docOjb.url);
                            $document.find(".btn-container").removeClass("hide")
                        }
                        $document.appendTo($parent.find(".documents-container"));
                    }
                    else {
                        console.log(result.error);
                        $('#loadingModal').find(".error").removeClass("hide").html(result.error);
                    }
                },
                error: function(result) {
                }
            });
        });

        let $adminContainer = $(".admin-notes-container");
        $adminContainer.on("change", ".admin-notes", function() {
            var $sellerId = $adminContainer.attr("storeId");
            let $this = $(this);
            $.ajax({
                type: "PUT",
                url: "/sellers/" + $sellerId + "/update_admin_info",
                data: { notes: $this.val(), is_admin: true },
                success: function(result) {
                    $adminContainer.find(".fa-check-circle").attr("style", "color:#27c24c;");
                },
                error: function(result) {
                }
            });
        });

        $adminContainer.on("keyup", ".admin-notes", function() {
            $adminContainer.find(".fa-check-circle").removeAttr("style");
        });
    }

    if ($(".admin-product-index").length) {
        $(".specific-product-status").on('click', '.dropdown-menu a', function() {
            var $this = $(this);
            var text = $this.html();
            var htmlText = text + ' <span class="caret"></span>';
            var $status = $this.attr("value");
            var $prodId = $this.attr("prodId");
            var $toggle = $this.closest('.dropdown').find('.dropdown-toggle');

            $toggle.prop('disabled', 'disabled');
            $toggle.find("span.title").hide();
            $toggle.find(".loading").show();
            $.ajax({
                type: "PUT",
                url: "/products/" + $prodId + "/set_status",
                data: { status: $status },
                success: function(result) {
                    $toggle.prop('disabled', false);
                    $toggle.removeClass("btn-success btn-danger");
                    $toggle.addClass($status == 0 ? "btn-success" : "btn-danger");
                    $toggle.find("span.title").html(htmlText);
                    $toggle.find(".loading").hide();
                    $toggle.find("span.title").show();
                },
                error: function(result) {
                }
            });
        });

        $(".admin-product-index").on("keypress", ".search-input", function(e) {
            if (e.key == "Enter") {
                var search_text = $(this).val();

                // Extract store ID from URL
                var pathSegments = window.location.pathname.split("/");
                var storeIdIndex = pathSegments.indexOf("sellers") + 1;
                var store_id = storeIdIndex > 0 && pathSegments[storeIdIndex] ? pathSegments[storeIdIndex] : null;

                var url = "/search.js";
                if (search_text != "") {
                    url = url + "?search=" + encodeURIComponent(search_text);
                }

                $.ajax({
                    type: "GET",
                    url: url,
                    data: { "type": "admin-products-index", "store_id": store_id, page: 1 },
                    success: function() {
                        console.log("Search results loaded successfully.");
                    },
                    error: function() {
                        console.error("Error fetching search results.");
                    }
                });
            }
        });

        $(".admin-product-index").on("click", ".send-invitation-button", function() {
            var $popup = $(".invitation-popup");
            $popup.find(".loading-seller.whirl.no-overlay, .buttons.confirm, .message, .error").addClass("hide");
            $popup.find(".invitation-text, .buttons.main").removeClass("hide");
            $popup.find(".message, .error").html("");
            $popup.show();
            $popup.css("height", $(document).height() - 10);
            $popup.find(".invitation-text span").html($(".admin-product-index").find(".email").html());
            $popup.find(".id").attr("value", $(this).attr("store_details_id"));

            $("html, body").animate({ scrollTop: 0 }, "slow");
        });

        $(".invitation-popup").on("click", ".btn-send", function() {
            var $popup = $(".invitation-popup");
            $popup.find(".loading-seller.whirl.no-overlay").removeClass("hide");
            $popup.find(".invitation-text, .buttons.main").addClass("hide");
            $.ajax({
                type: "POST",
                url: "/sellers/send_invitation",
                data: { id: $(".invitation-popup").find(".id").attr("value") },
                success: function(result) {
                    if (result.status != 300) {
                        $popup.find(".message").html(result.message);
                        $popup.find(".message").removeClass("hide");
                    }
                    else {
                        $popup.find(".error").html(result.error);
                        $popup.find(".error").removeClass("hide");
                    }
                    $popup.find(".buttons.confirm").removeClass("hide");
                    $popup.find(".whirl.no-overlay").addClass("hide");
                }
            });
        });

        $(".invitation-popup").on("click", ".btn-cancel, .btn-ok", function() {
            $(".invitation-popup").hide();
        });

        var $block = "";
        $(".admin-product-index").on("click", ".block-product", function() {
            $block = "blocked";
            $("#blockProduct").find(".modal-title").html("BLOCK PRODUCT");
            $("#blockProduct").find(".block-btn, .block-question, .question-row").removeClass("hide");
            $("#blockProduct").find(".unblock-btn, .unblock-question").addClass("hide");
            $("#blockProduct").find(".block-btn").attr("prodId", $(this).attr("prodId"));
        });

        $(".admin-product-index").on("click", ".unblock-product", function() {
            $block = "active";
            $("#blockProduct").find(".modal-title").html("UNBLOCK PRODUCT");
            $("#blockProduct").find(".block-btn, .block-question").addClass("hide");
            $("#blockProduct").find(".unblock-btn, .unblock-question, .question-row").removeClass("hide");
            $("#blockProduct").find(".unblock-btn").attr("prodId", $(this).attr("prodId"));
        });

        $("#blockProduct").on("click", ".block-btn, .unblock-btn", function() {
            var $this = $(this);
            var $popup = $(this).parents(".modal-body");
            var $prodId = $this.attr("prodId");
            var $form = $popup.find("form");
            $popup.find(".whirl").removeClass("hide");
            $popup.find("button.close").css("visibility", "hidden");
            $popup.find(".message-row, .message").removeClass("hide");

            $.ajax({
                type: "PUT",
                url: "/sellers/products/" + $prodId + "/block",
                data: { status: $block },
                success: function(result) {
                    $popup.find("button.close").css("visibility", "visible");
                    $popup.find(".whirl").addClass("hide");
                    if (result.status == 200) {
                        $popup.find(".main-buttons-row").addClass("hide");
                        $popup.find(".message-row, .message, .confirm-button-row").removeClass("hide");
                        $popup.find(".message-row .message").html(result.message);
                    }
                    else {
                        $popup.find(".message-row, .error").removeClass("hide");
                        $popup.find(".message-row .error").html(result.error);
                    }
                }
            })
        });

        $("#blockProduct").on("click", ".btn-confirm", function() {
            window.location.reload();
        });
    }

    if ($(".admin-product-show").length) {
        $("#editReferral").on("click", ".btn-update", function() {
            var $parent = $(this).parents("#editReferral");
            var $form = $parent.find(".product-info");
            $parent.find(".loading-row, .main-buttons-row").removeClass("hide");
            $.ajax({
                type: "POST",
                url: "/sellers/products/update",
                data: new FormData($form[0]),
                contentType: false,
                cache: false,
                processData: false,
                success: function(result) {
                    $parent.find(".loading-row").addClass("hide");
                    $parent.find(".message-row, .main-buttons-row").removeClass("hide");
                    if (result.status == 200) {
                        $(".admin-product-show").find(".referal-value").html($form.find(".input-referral").val())
                        $parent.find(".message").removeClass("hide").html("Successfully updated referral");
                    }
                    else {
                        $parent.find(".error").removeClass("hide").html(result.error);
                    }
                }
            });
        });
    }
    let selectedProducts = [];

    $(document).on("click", "#upload-button", function() {
        console.log('Opened Modal');
        $("#upload-modal").css("display", "flex");
    });

    $(document).on("click", "#close-modal", function() {
        $("#upload-modal").css("display", "none");
    });

    $(document).on("change", "#file-input", function(event) {
        let file = event.target.files[0];

        if (!file) return;

        let reader = new FileReader();
        reader.onload = function(e) {
            let csvData = e.target.result;
            $("#loading-spinner").show();
            parseCSV(csvData);
        };
        reader.readAsText(file);
    });

    function parseCSV(csv) {
        Papa.parse(csv, {
            header: true,
            skipEmptyLines: true,
            complete: function(result) {
                let html = "";
                selectedProducts = [];

                result.data.forEach((row, index) => {
                    let product = {
                        id: index,
                        name: row["Name"] ? row["Name"].trim() : "",
                        description: row["description"] || "",
                        company_id_no: row["company_id_no"] || "",
                        weight: row["weight"] || "",
                        length: row["length"] || "",
                        width: row["width"] || "",
                        height: row["height"] || "",
                        weight_type: row["weight_type"] || "",
                        unit_measure: row["unit_measure"] || "",
                        shipment_unit_measure: row["shipment_unit_measure"] || "",
                        price: cleanPrice(row["price"]),
                        sale_price: cleanPrice(row["sale_price"]),
                        manufacturer: row["manufacturer/brand"] || "",
                        quantity: parseInt(row["inventory"]) || 0,
                        image_url: row["image_urls"],
                        sub_category_id: row["sub_category_id"] || "",
                        pack_shot_size: row["pack_shot_size"] || 1,
                        override: row["override"] || "YES"
                    };

                    selectedProducts.push(product);

                    html += `<tr>
                            <td><input type="checkbox" class="select-product" data-id="${product.id}" checked></td>
                            <td>${product.name}</td>
                            <td>${product.price}</td>
                            <td>${product.quantity}</td>
                            <td>${product.sale_price}</td>
                            <td>${product.pack_shot_size}</td>
                        </tr>`;
                });

                $("#preview-body").html(html);
                $("#loading-spinner").hide();
                $("#product-preview, #upload-selected, #upload-all").show();
            }
        });
    }

    function cleanPrice(value) {
        return parseFloat(value.replace(/[^\d.]/g, "")) || 0.0;
    }

    $(document).on("change", "#select-all-checkbox", function() {
        $(".select-product").prop("checked", $(this).prop("checked"));
    });

    $(document).on("click", "#upload-selected", function() {
        let selected = $(".select-product:checked").map(function() {
            return selectedProducts.find(p => p.id == $(this).data("id"));
        }).get();

        if (selected.length === 0) {
            alert("Please select at least one product to upload.");
            return;
        }

        uploadProducts(selected);
    });

    $(document).on("click", "#upload-all", function() {
        uploadProducts(selectedProducts);
    });

    function uploadProducts(products) {
        $("#loading-spinner").show();

        let sellerId = window.location.pathname.split("/")[2];

        $.ajax({
            url: "/products/import_files",
            type: "POST",
            data: JSON.stringify({ products: products, seller_id: sellerId }),
            contentType: "application/json",
            headers: {
                "X-CSRF-Token": $("meta[name='csrf-token']").attr("content")
            },
            success: function(response) {
                $("#loading-spinner").hide();

                if (response.success) {
                    $("#upload-modal").hide();
                    location.reload();
                } else {
                    alert("Error uploading CSV: " + response.error);
                }
            },
            error: function(xhr) {
                $("#loading-spinner").hide();
                alert("Error: " + xhr.responseText);
            }
        });
    }

    // function checkEmailFormat(email) {
    //   return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
    // } old format
    function checkEmailFormat(email) {
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
    }
    function lettersOnly() {
        var charCode = event.keyCode;
        if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8 || charCode == 32)
            return true;
        else
            return false;
    }
});
